import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin');
import { HostListener, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { FitAddon } from '@xterm/addon-fit';
import { WebLinksAddon } from '@xterm/addon-web-links';
import { Terminal } from '@xterm/xterm';
import Chart from 'chart.js/auto';
import { Service } from "src/libs/portal/season/service";
import { io } from 'socket.io-client';

@Component({
    selector: 'wiz-page-admin',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.admin/view.scss */
/* src/app/page.admin/view.scss: no such file or directory */`],
})
export class PageAdminComponent implements OnInit, OnDestroy {
    public activeTab: string = 'dashboard';
    public loading: boolean = true;
    public loadingContext: string = 'initial';
    public loadingTargetTab: string = 'dashboard';
    public loadingTargetPage: number = 0;
    public savingUserId: string = '';
    public approvingUserId: string = '';
    public restoringGroupId: string = '';
    public dashboardWeekStart: string = '';
    public dashboard: any = {
        period: {
            start: '',
            end: '',
            label: '',
            previous_start: '',
            next_start: '',
            current_start: '',
            is_current: true,
            timezone: 'UTC+9'
        },
        totals: {
            users: 0,
            approved_users: 0,
            pending_users: 0,
            admin_users: 0,
            reviews: 0,
            activities: 0,
            codex_works: 0,
            codex_duration_seconds: 0,
            codex_duration_label: '0분',
            codex_accounts: 0
        },
        rankings: { reviews: [], activities: [], codex_users: [], codex_accounts: [] },
        activity_users: [],
        chart: { days: [], hours: [], hour_slots: [], max_count: 1, hourly_max_count: 1, hour_slot_max_count: 1, timezone: 'UTC+9' }
    };
    public dashboardSeries: any[] = [
        { key: 'review_count', label: '리뷰', color: '#fb7185' },
        { key: 'activity_count', label: '작업이력', color: '#f59e0b' },
        { key: 'codex_count', label: '에이전트 요청', color: '#6366f1' }
    ];
    public dashboardChartSelection: any = { daily: '', hourly: '', hourSlots: '' };
    public chartPlot: any = { left: 56, right: 1088, top: 18, bottom: 218 };
    public userActivityGuideOpen: boolean = false;
    public userDashboardOpen: boolean = false;
    public userDashboardLoading: boolean = false;
    public userActivityExporting: boolean = false;
    public selectedDashboardUser: any = null;
    public userActivityWeekStart: string = '';
    public userActivityDashboard: any = {
        user: { id: '', name: '', email: '', role: '', account_status_label: '', signup_provider: '', last_login_at: '', created: '' },
        period: { start: '', end: '', label: '', previous_start: '', next_start: '', current_start: '', is_current: true, timezone: 'UTC+9' },
        totals: { reviews: 0, activities: 0, codex_requests: 0, codex_duration_seconds: 0, codex_duration_label: '0분', active_days: 0, active_hours: 0, projects: 0, touched_reviews: 0 },
        chart: { days: [], hours: [], max_count: 1, hourly_max_count: 1, timezone: 'UTC+9' },
        distributions: { statuses: [], categories: [] },
        rankings: { projects: [] },
        productivity: { score: 0, metrics: [], days: [], baselines: {}, formula: '' },
        evaluation: { score: 0, metrics: [], methodology: [] },
        activity: { weekly: { score: 0 }, monthly: { score: 0 } }
    };
    public users: any[] = [];
    public groups: any[] = [];
    public projects: any[] = [];
    public reviews: any[] = [];
    public codexSubTab: string = 'accounts';
    public codexRefreshing: boolean = false;
    public codexResettingAccountId: string = '';
    public codexAccounts: any[] = [];
    public codexProjectGroups: any[] = [];
    public codexProjectTotal: number = 0;
    public codexProjectCollapsed: any = {};
    public codexProjectErrorLogModal: any = { open: false, loading: false, project: null, logs: [], selected: null, total: 0, limit: 50, period_label: '최근 12시간', error: '' };
    public selectedCodexProjectLogin: any = null;
    public projectCodexLoginAuth: any = null;
    public projectCodexLoginResult: any = null;
    public projectCodexLoginBusyId: string = '';
    public codexRequests: any[] = [];
    public codexRequestTotal: number = 0;
    public codexRequestPage: number = 1;
    public codexRequestPageSize: number = 50;
    public codexRequestFilter: any = { status: 'active' };
    public selectedCodexLoginRequest: any = null;
    public codexLoginRequestBusyId: string = '';
    public codexLoginRequestAuth: any = null;
    public codexCopiedDeviceCodeKey: string = '';
    public codexLoginRequestCancelTarget: any = null;
    public codexLoginRequestCancelReason: string = '';
    public codexRequestTerminalOpen: boolean = false;
    public codexRequestTerminalMode: string = 'request';
    public codexRequestTerminalRequest: any = null;
    public codexRequestTerminalProject: any = null;
    public codexRequestTerminalStarting: boolean = false;
    public codexRequestTerminalReady: boolean = false;
    public codexRequestTerminalError: string = '';
    public codexRequestTerminalStatusMessage: string = '';
    private codexRequestTerminal: any = null;
    private codexRequestTerminalHostElement: any = null;
    private codexRequestTerminalFitAddon: any = null;
    private codexRequestTerminalWebLinksAddon: any = null;
    private codexRequestTerminalInputDisposable: any = null;
    private codexRequestTerminalResizeTimer: any = null;
    private codexRequestTerminalConnectTimer: any = null;
    private codexRequestTerminalSocket: any = null;
    private codexRequestTerminalSocketConnected: boolean = false;
    private codexRequestTerminalSocketConnecting: boolean = false;
    public codexLogs: any[] = [];
    public codexLogTotal: number = 0;
    public codexLogPage: number = 1;
    public codexLogPageSize: number = 20;
    public codexLogFilter: any = { error: '', requester: '', account: '' };
    public codexLogFilterSearch: any = { requester: '', account: '' };
    public codexLogFilterOpen: any = { requester: false, account: false };
    public codexLogOptions: any = { requesters: [], accounts: [] };
    public selectedCodexLog: any = null;
    private codexLogDetailRequestSeq: number = 0;
    public codexAccountUsageOpen: boolean = false;
    public codexAccountUsageLoading: boolean = false;
    public selectedCodexAccount: any = null;
    public codexAccountUsageDashboard: any = {
        account: { label: '', email: '', name: '', plan: '', organization: '', status: '', last_checked: '' },
        period: { start: '', end: '', label: '', timezone: 'UTC+9' },
        totals: {
            requests: 0,
            success_requests: 0,
            error_requests: 0,
            duration_seconds: 0,
            duration_label: '0분',
            status_snapshots: 0,
            status_hours: 0,
            status_days: 0,
            current_remaining_weekly: ''
        },
        chart: { hours: [], days: [] }
    };
    public uploadSettings: any = { locations: [], policies: {} };
    public uploadSettingsForm: any = { locations: [], policies: {} };
    public uploadPolicyGroupList: any[] = [];
    public savingUploadSettings: boolean = false;
    public uploadCategoryCollapsed: any = {};
    public uploadPolicyCollapsed: any = {};
    public systemSubTab: string = 'monitoring';
    public systemResponseLogTab: string = 'top_average';
    public systemTrafficPeriod: string = '24h';
    public systemResponsePeriod: string = '3h';
    public systemMonitoringRefreshing: boolean = false;
    public systemTrafficLoading: boolean = false;
    public systemResponseLogLoading: boolean = false;
    public systemCronRefreshing: boolean = false;
    public systemCronInstallingKey: string = '';
    public systemTerminalRefreshing: boolean = false;
    public systemMonitoring: any = {
        generated_at: '',
        storage: {
            path: '/mnt/data',
            exists: false,
            total_label: '0B',
            used_label: '0B',
            free_label: '0B',
            folder_label: '0B',
            used_percent: 0,
            child_count: 0,
            top_children: []
        },
        web_logs: {
            entry_count: 0,
            source_count: 0,
            period_label: '최근 3시간 로그 없음',
            latest_at: '',
            timezone: 'UTC+9',
            sources: [],
            top_average: [],
            top_max: [],
            top_errors: [],
            recent_slow: [],
            duration_histogram: [],
            hourly_errors: [],
            traffic_chart: {
                key: '24h',
                interval_minutes: 10,
                window_hours: 24,
                bucket_label: '10분',
                period_label: '최근 24시간 · 10분 단위 · UTC+9 기준',
                total_count: 0,
                peak_count: 0,
                buckets: []
            }
        }
    };
    public systemLogChartModal: any = {
        open: false,
        type: 'duration',
        title: '',
        subtitle: '',
        row: null,
        loading: false,
        requestKey: ''
    };
    public systemCron: any = {
        generated_at: '',
        service: { available: false, running: false, name: '', message: '' },
        crontab_available: false,
        crontab_error: '',
        total_count: 0,
        registered_count: 0,
        missing_count: 0,
        warning_count: 0,
        latest_run_at: '',
        latest_run_age: '-',
        jobs: []
    };
    public systemTerminalSessions: any = {
        generated_at: '',
        sync_method: 'DB heartbeat',
        stale_threshold_seconds: 180,
        active_count: 0,
        stale_count: 0,
        closed_count: 0,
        total_count: 0,
        worker_count: 0,
        workers: [],
        rows: []
    };
    public uploadExtensionSuggestions: string[] = [
        '.pdf', '.png', '.jpg', '.jpeg', '.gif', '.webp', '.svg',
        '.txt', '.md', '.csv', '.json', '.zip',
        '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx',
        '.fig', '.ai', '.psd', '.sketch',
        '.html', '.css', '.js', '.ts', '.tsx', '.scss',
        '.woff', '.woff2', '.ttf', '.otf', '.mp4', '.mov', '.webm'
    ];
    public uploadMimeSuggestions: string[] = [
        'image/*', 'text/*', 'video/*', 'font/*',
        'application/pdf', 'image/png', 'image/jpeg', 'image/gif', 'image/webp', 'image/svg+xml',
        'text/plain', 'text/markdown', 'text/csv', 'text/html', 'text/css',
        'application/json', 'application/javascript', 'application/zip',
        'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/postscript', 'application/vnd.sketch', 'video/mp4', 'video/quicktime', 'video/webm',
        'font/woff', 'font/woff2', 'font/ttf', 'font/otf'
    ];
    private readonly uploadPolicySuggestionMap: any = {
        project_document: {
            extension: ['.pdf', '.pptx', '.docx', '.xlsx'],
            mime: ['application/pdf', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
        },
        html_reference_file: {
            extension: ['.pdf', '.txt', '.md', '.csv', '.json', '.docx', '.xlsx', '.pptx', '.zip'],
            mime: ['application/pdf', 'text/*', 'application/json', 'application/zip']
        },
        html_resource_file: {
            extension: ['.png', '.jpg', '.jpeg', '.webp', '.svg', '.fig', '.ai', '.psd', '.sketch', '.zip'],
            mime: ['image/*', 'image/svg+xml', 'application/zip', 'application/postscript']
        },
        review_attachment: {
            extension: ['.png', '.jpg', '.jpeg', '.webp', '.pdf', '.docx', '.xlsx', '.pptx', '.zip'],
            mime: ['image/*', 'application/pdf', 'application/zip', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
        },
        activity_attachment: {
            extension: ['.png', '.jpg', '.jpeg', '.webp', '.pdf', '.docx', '.xlsx', '.pptx', '.zip'],
            mime: ['image/*', 'application/pdf', 'application/zip', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
        },
        intro_attachment: {
            extension: ['.pdf', '.docx', '.xlsx', '.pptx', '.zip'],
            mime: ['application/pdf', 'application/zip', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
        }
    };
    private readonly uploadPolicyCategoryMap: any = {
        project_create: {
            key: 'project_create',
            label: '프로젝트 생성/기본 정보',
            description: '프로젝트를 만들거나 소개 정보를 등록할 때 사용하는 업로드입니다.',
            icon: 'fa-solid fa-folder-plus'
        },
        project_files: {
            key: 'project_files',
            label: '프로젝트 상세 파일 관리',
            description: '프로젝트 상세 화면의 공용파일, 소스, 에셋 업로드입니다.',
            icon: 'fa-solid fa-folder-open'
        },
        html_document_settings: {
            key: 'html_document_settings',
            label: 'HTML 문서 설정',
            description: 'HTML 문서/발표자료 프로젝트의 참고자료와 디자인 리소스 업로드입니다.',
            icon: 'fa-solid fa-file-lines'
        },
        review_workflow: {
            key: 'review_workflow',
            label: '리뷰/작업이력',
            description: '리뷰 작성과 처리 이력에서 증빙 파일을 첨부하는 업로드입니다.',
            icon: 'fa-solid fa-comments'
        }
    };
    private readonly uploadPolicyCategoryOrder: string[] = ['project_create', 'project_files', 'html_document_settings', 'review_workflow'];
    private readonly uploadPolicyContextMap: any = {
        project_document: {
            category: 'project_create',
            screen: '프로젝트 생성/문서 버전',
            target: '문서 원본 파일',
            description: '문서 프로젝트를 만들거나 새 버전을 올릴 때 선택하는 기준 파일입니다.'
        },
        intro_attachment: {
            category: 'project_create',
            screen: '프로젝트 생성/소개 정보',
            target: '소개 첨부 파일',
            description: '프로젝트 소개, 요청사항, 참고 문서에 보조 파일을 붙일 때 적용됩니다.'
        },
        project_file: {
            category: 'project_files',
            screen: '프로젝트 상세 > 파일',
            target: '웹서비스 공용파일',
            description: '웹서비스 프로젝트의 공용 파일 업로드와 파일 브라우저 업로드에 적용됩니다.'
        },
        html_project_file: {
            category: 'project_files',
            screen: '프로젝트 상세 > HTML 파일',
            target: 'HTML 프로젝트 파일',
            description: 'HTML 프로젝트 파일 탭에서 소스, 이미지, 에셋을 올릴 때 적용됩니다.'
        },
        html_reference_file: {
            category: 'html_document_settings',
            screen: '프로젝트 상세 > 문서 설정',
            target: 'HTML 참고자료',
            description: '에이전트 작업에 참고시킬 기획서, 표, 문서, 압축 파일 업로드에 적용됩니다.'
        },
        html_resource_file: {
            category: 'html_document_settings',
            screen: '프로젝트 상세 > 문서 설정',
            target: 'HTML 리소스',
            description: '디자인 시안, 이미지, 폰트, 리소스 묶음 업로드에 적용됩니다.'
        },
        review_attachment: {
            category: 'review_workflow',
            screen: '리뷰 작성/수정',
            target: '리뷰 첨부',
            description: '리뷰 본문에 첨부하는 스크린샷, 문서, 증빙 파일에 적용됩니다.'
        },
        activity_attachment: {
            category: 'review_workflow',
            screen: '리뷰 상세 > 작업이력',
            target: '작업이력 첨부',
            description: '상태 변경이나 처리 기록을 남길 때 첨부하는 파일에 적용됩니다.'
        }
    };
    public reviewOptions: any = { users: [], groups: [], projects: [] };
    public reviewOptionsLoaded: boolean = false;
    public reviewTotal: number = 0;
    public userFilter: any = { text: '', role: '', active: '' };
    public groupFilter: any = { text: '', status: '', visibility: '' };
    public projectFilter: any = { text: '', status: '', visibility: '', codex_status: '', codex_account: '' };
    public reviewFilter: any = { user_id: '', group_id: '', project_id: '' };
    public reviewFilterSearch: any = { user: '', group: '', project: '' };
    public reviewFilterOpen: any = { user: false, group: false, project: false };
    public userPage: number = 1;
    public userPageSize: number = 10;
    public groupPage: number = 1;
    public groupPageSize: number = 10;
    public projectPage: number = 1;
    public projectPageSize: number = 10;
    public projectTotal: number = 0;
    public reviewPage: number = 1;
    public reviewPageSize: number = 12;
    public reviewStatusCounts: any = { open: 0, in_progress: 0, in_review: 0, resolved: 0, recheck: 0, closed: 0 };
    public reviewStatusOptions: any[] = [
        { value: '', label: '전체 상태' },
        { value: 'open', label: '열림' },
        { value: 'in_progress', label: '진행' },
        { value: 'in_review', label: '검토' },
        { value: 'resolved', label: '해결' },
        { value: 'recheck', label: '재검토' },
        { value: 'closed', label: '닫힘' }
    ];
    private chartInstances: any = {};
    private chartRenderTimer: any = null;
    private uploadSettingsRenderTimer: any = null;
    private routeSubscription: any = null;
    private workspaceDetached: boolean = false;
    private loadGeneration: number = 0;
    private activeLoadKey: string = '';
    private activeLoadPromise: Promise<void> | null = null;
    private readonly adminTabs: string[] = ['dashboard', 'users', 'groups', 'projects', 'reviews', 'codex', 'system'];
    constructor(@Inject( Service) public service: Service,@Inject( Router)  public router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/login');
        this.activeTab = this.routeTab();
        this.routeSubscription = this.router.events.subscribe(async (event: any) => {
            if (event instanceof NavigationEnd) {
                await this.handleRouteTabChange(event.urlAfterRedirects || event.url || `${location.pathname}${location.search}`);
            }
        });
        await this.load('initial');
    }

    public ngOnDestroy() {
        this.loadGeneration += 1;
        this.codexLogDetailRequestSeq += 1;
        if (this.routeSubscription && this.routeSubscription.unsubscribe) this.routeSubscription.unsubscribe();
        this.routeSubscription = null;
        this.stopCodexRequestTerminal(false);
        this.disposeCodexRequestTerminal();
        this.disconnectCodexRequestTerminalSocket();
        if (this.codexRequestTerminalResizeTimer) {
            clearTimeout(this.codexRequestTerminalResizeTimer);
            this.codexRequestTerminalResizeTimer = null;
        }
        this.clearCodexRequestTerminalConnectTimer();
        this.destroyCharts();
        if (this.chartRenderTimer) {
            clearTimeout(this.chartRenderTimer);
            this.chartRenderTimer = null;
        }
        if (this.uploadSettingsRenderTimer) {
            clearTimeout(this.uploadSettingsRenderTimer);
            this.uploadSettingsRenderTimer = null;
        }
    }

    public reviewopsWorkspaceDetached() {
        this.workspaceDetached = true;
    }

    public reviewopsWorkspaceAttached() {
        const wasDetached = this.workspaceDetached;
        this.workspaceDetached = false;
        if (!wasDetached) return;
        this.scheduleChartRender();
        if (this.codexRequestTerminalOpen) this.scheduleCodexRequestTerminalFit();
    }

    @HostListener('window:resize')
    public onWindowResize() {
        if (this.workspaceDetached) return;
        if (this.codexRequestTerminalOpen) this.scheduleCodexRequestTerminalFit();
    }

    public async setTab(tab: string) {
        const nextTab = this.normalizeAdminTab(tab);
        const nextPath = this.adminTabPath(nextTab);
        if (this.cleanPath(location.pathname) !== nextPath) {
            if (this.activeTab !== nextTab) {
                this.loadGeneration += 1;
                this.beginLoadingTransition('tab', nextTab);
                await this.service.render();
            }
            this.service.href(nextPath);
            return;
        }
        await this.activateTab(nextTab);
    }

    public async handleRouteTabChange(path: string = `${location.pathname}${location.search}`) {
        if (this.workspaceDetached) return;
        await this.activateTab(this.routeTab(path));
    }

    public async activateTab(tab: string) {
        tab = this.normalizeAdminTab(tab);
        if (this.activeTab === tab) {
            await this.service.render();
            return;
        }
        this.activeTab = tab;
        if (this.isReviewTab()) {
            this.normalizeReviewAxisFilter();
        }
        if (tab === 'users') this.userPage = 1;
        if (tab === 'groups') this.groupPage = 1;
        if (tab === 'projects') this.projectPage = 1;
        if (tab === 'reviews') this.reviewPage = 1;
        if (tab === 'codex' && !['accounts', 'projects', 'requests', 'logs'].includes(this.codexSubTab)) this.codexSubTab = 'accounts';
        if (tab === 'system' && !['upload', 'monitoring', 'terminal', 'cron'].includes(this.systemSubTab)) this.systemSubTab = 'monitoring';
        await this.load('tab');
    }

    public routeTab(path: string = `${location.pathname}${location.search}`) {
        try {
            const value = String(path || `${location.pathname}${location.search}`);
            const cleanPath = this.cleanPath(value.split('?')[0]);
            const query = value.split('?')[1] || '';
            const queryTab = new URLSearchParams(query).get('tab') || '';
            return this.normalizeAdminTab(this.tabFromPath(cleanPath) || queryTab);
        } catch (e) {
            return 'dashboard';
        }
    }

    public normalizeAdminTab(tab: string) {
        const key = String(tab || '').trim().toLowerCase();
        const aliases: any = {
            main: 'dashboard',
            home: 'dashboard',
            'user-reviews': 'reviews',
            'group-reviews': 'reviews',
            user_reviews: 'reviews',
            group_reviews: 'reviews',
            'codex-accounts': 'codex',
            'codex-projects': 'codex',
            'codex-logs': 'codex',
            'codex-requests': 'codex',
            codex_accounts: 'codex',
            codex_projects: 'codex',
            codex_logs: 'codex',
            codex_requests: 'codex',
            settings: 'system',
            'system-settings': 'system',
            system_settings: 'system'
        };
        const value = aliases[key] || key;
        return this.adminTabs.includes(value) ? value : 'dashboard';
    }

    public adminTabPath(tab: string) {
        return `/admin/${this.normalizeAdminTab(tab)}`;
    }

    public tabFromPath(path: string) {
        const cleanPath = this.cleanPath(path);
        if (cleanPath === '/admin') return '';
        if (cleanPath.indexOf('/admin/') !== 0) return '';
        const segment = cleanPath.slice('/admin/'.length).split('/')[0] || '';
        try {
            return decodeURIComponent(segment);
        } catch (e) {
            return segment;
        }
    }

    public cleanPath(path: string) {
        const cleanPath = String(path || '').split('?')[0].replace(/\/+$/, '');
        return cleanPath || '/';
    }

    public isReviewTab(tab: string = this.activeTab) {
        return tab === 'reviews';
    }

    public isCodexTab(tab: string = this.activeTab) {
        return tab === 'codex';
    }

    public adminTabLabel(tab: string = this.activeTab) {
        const labels: any = {
            dashboard: '대시보드',
            users: '사용자',
            groups: '그룹',
            projects: '프로젝트',
            reviews: '리뷰',
            codex: '에이전트',
            system: '시스템'
        };
        return labels[this.normalizeAdminTab(tab)] || '관리자';
    }

    public loadingSectionLabel() {
        const tab = this.normalizeAdminTab(this.loadingTargetTab || this.activeTab);
        if (tab === 'codex') return this.codexSubTabTitle();
        if (tab === 'system') return this.systemSubTabTitle();
        return this.adminTabLabel(tab);
    }

    public loadingTitle() {
        return `${this.loadingSectionLabel()} 불러오는 중`;
    }

    public loadingDescription() {
        if (this.loadingContext === 'page' && this.loadingTargetPage > 0) {
            return `${this.loadingTargetPage}페이지로 이동하고 있습니다.`;
        }
        if (this.loadingContext === 'filter') return '선택한 조건에 맞는 최신 결과를 조회하고 있습니다.';
        if (this.loadingContext === 'period') return '선택한 기간의 통계를 다시 집계하고 있습니다.';
        if (this.loadingContext === 'tab') return '선택한 관리 화면을 준비하고 있습니다.';
        if (this.loadingContext === 'initial') return '관리자 화면에 필요한 데이터를 준비하고 있습니다.';
        return '최신 데이터로 화면을 갱신하고 있습니다.';
    }

    public isAdminTabSelected(tab: string) {
        const selected = this.loading && this.loadingContext === 'tab' && this.loadingTargetTab
            ? this.loadingTargetTab
            : this.activeTab;
        return selected === tab;
    }

    private beginLoadingTransition(context: string = 'refresh', targetTab: string = this.activeTab, targetPage: number = 0) {
        this.loadingContext = context || 'refresh';
        this.loadingTargetTab = this.normalizeAdminTab(targetTab || this.activeTab);
        this.loadingTargetPage = Math.max(0, Number(targetPage) || 0);
        this.loading = true;
    }

    private revealLoadingState() {
        window.requestAnimationFrame(() => {
            const element = document.getElementById('admin-loading-state');
            if (!element) return;
            const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            element.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        });
    }

    public async searchUsers() {
        this.userPage = 1;
        await this.load('filter');
    }

    public async searchGroups() {
        this.groupPage = 1;
        await this.load('filter');
    }

    public async searchProjects() {
        this.projectPage = 1;
        await this.load('filter');
    }

    public async searchReviews() {
        this.normalizeReviewAxisFilter();
        this.reviewPage = 1;
        await this.load('filter');
    }

    public async setCodexSubTab(tab: string) {
        if (!['accounts', 'projects', 'requests', 'logs'].includes(tab) || this.codexSubTab === tab) return;
        this.codexSubTab = tab;
        if (this.activeTab === 'codex') {
            await this.load('tab');
            return;
        }
        await this.service.render();
    }

    public async setSystemSubTab(tab: string) {
        if (!['upload', 'monitoring', 'terminal', 'cron'].includes(tab) || this.systemSubTab === tab) return;
        this.systemSubTab = tab;
        if (this.activeTab === 'system') {
            await this.load('tab');
            return;
        }
        await this.service.render();
    }

    public codexSubTabTitle(tab: string = this.codexSubTab) {
        const labels: any = { accounts: 'OpenAI 계정', projects: '에이전트 프로젝트', requests: '에이전트 요청', logs: '에이전트 로그' };
        return labels[tab] || '에이전트';
    }

    public systemSubTabTitle(tab: string = this.systemSubTab) {
        const labels: any = { upload: '파일업로드', monitoring: '성능 모니터링', terminal: '터미널 세션', cron: 'Cron 상태' };
        return labels[tab] || '시스템';
    }

    public async setSystemResponseLogTab(tab: string) {
        if (!['top_average', 'top_max', 'recent_slow', 'top_errors'].includes(tab) || this.systemResponseLogTab === tab) return;
        this.systemResponseLogTab = tab;
        await this.service.render();
    }

    public async searchCodexLogs() {
        this.codexLogPage = 1;
        await this.load('filter');
    }

    public async searchCodexRequests() {
        this.codexRequestPage = 1;
        await this.load('filter');
    }

    public async setCodexRequestStatus(value: string) {
        if (this.codexRequestFilter.status === value) return;
        this.codexRequestFilter.status = value;
        await this.searchCodexRequests();
    }

    public async setCodexLogError(value: string) {
        if (this.codexLogFilter.error === value) return;
        this.codexLogFilter.error = value;
        await this.searchCodexLogs();
    }

    public async clearCodexLogFilters() {
        this.codexLogFilter = { error: '', requester: '', account: '' };
        this.codexLogFilterSearch = { requester: '', account: '' };
        this.codexLogFilterOpen = { requester: false, account: false };
        this.codexLogPage = 1;
        await this.load('filter');
    }

    public async refreshCodexSubTab() {
        if (this.activeTab !== 'codex' || this.codexRefreshing) return;
        this.codexRefreshing = true;
        await this.service.render();

        const refreshParams = Object.assign(this.params(), {
            active_tab: 'codex',
            codex_refresh_target: this.codexSubTab
        });
        try {
            const { code, data } = await wiz.call('load', refreshParams);
            if (code === 200) {
                this.applyCodexData(data || {});
            } else {
                await this.service.modal.error((data && data.message) || '에이전트 목록을 새로고침하지 못했습니다.');
            }
        } catch (e) {
            await this.service.modal.error('에이전트 목록을 새로고침하지 못했습니다.');
        } finally {
            this.codexRefreshing = false;
            await this.service.render();
        }
    }

    public async refreshSystemMonitoring(scope: string = 'all') {
        if (this.activeTab !== 'system' || this.systemSubTab !== 'monitoring' || this.systemMonitoringRefreshing) return;
        const loadingTraffic = scope === 'all' || scope === 'traffic';
        const loadingResponse = scope === 'all' || scope === 'response';
        this.systemMonitoringRefreshing = true;
        if (loadingTraffic) {
            this.systemTrafficLoading = true;
            this.destroyCharts('systemTraffic');
        }
        if (loadingResponse) {
            this.systemResponseLogLoading = true;
        }
        await this.service.render();
        try {
            const { code, data } = await wiz.call('load', Object.assign(this.params(), {
                active_tab: 'system',
                system_sub_tab: 'monitoring'
            }));
            if (code === 200) {
                this.applyAdminData(data || {});
            } else {
                await this.service.modal.error((data && data.message) || '성능 모니터링 데이터를 새로고침하지 못했습니다.');
            }
        } catch (e) {
            await this.service.modal.error('성능 모니터링 데이터를 새로고침하지 못했습니다.');
        } finally {
            this.systemMonitoringRefreshing = false;
            if (loadingTraffic) this.systemTrafficLoading = false;
            if (loadingResponse) this.systemResponseLogLoading = false;
            await this.service.render();
            this.scheduleChartRender();
        }
    }

    public async refreshSystemCron() {
        if (this.activeTab !== 'system' || this.systemSubTab !== 'cron' || this.systemCronRefreshing) return;
        this.systemCronRefreshing = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('load', Object.assign(this.params(), {
                active_tab: 'system',
                system_sub_tab: 'cron'
            }));
            if (code === 200) {
                this.applyAdminData(data || {});
            } else {
                await this.service.modal.error((data && data.message) || 'Cron 상태를 새로고침하지 못했습니다.');
            }
        } catch (e) {
            await this.service.modal.error('Cron 상태를 새로고침하지 못했습니다.');
        } finally {
            this.systemCronRefreshing = false;
            await this.service.render();
        }
    }

    public async refreshSystemTerminalSessions() {
        if (this.activeTab !== 'system' || this.systemSubTab !== 'terminal' || this.systemTerminalRefreshing) return;
        this.systemTerminalRefreshing = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('load', Object.assign(this.params(), {
                active_tab: 'system',
                system_sub_tab: 'terminal'
            }));
            if (code === 200) {
                this.applyAdminData(data || {});
            } else {
                await this.service.modal.error((data && data.message) || '터미널 세션 목록을 새로고침하지 못했습니다.');
            }
        } catch (e) {
            await this.service.modal.error('터미널 세션 목록을 새로고침하지 못했습니다.');
        } finally {
            this.systemTerminalRefreshing = false;
            await this.service.render();
        }
    }

    public async installSystemCronJob(job: any) {
        if (!job || !job.key || this.systemCronInstallingKey) return;
        const ok = await this.service.modal.confirm({
            title: 'Cron 등록',
            message: `${job.title || 'Cron 작업'} 항목을 시스템 crontab에 등록할까요?`,
            action: '등록',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!ok) return;
        this.systemCronInstallingKey = job.key;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('install_system_cron_job', Object.assign(this.params(), {
                active_tab: 'system',
                system_sub_tab: 'cron',
                data: JSON.stringify({ key: job.key })
            }));
            if (code === 200) {
                this.applyAdminData(data || {});
                await this.service.modal.success('Cron 작업을 등록했습니다.');
            } else {
                await this.service.modal.error((data && data.message) || 'Cron 작업을 등록하지 못했습니다.');
            }
        } catch (e) {
            await this.service.modal.error('Cron 작업을 등록하지 못했습니다.');
        } finally {
            this.systemCronInstallingKey = '';
            await this.service.render();
        }
    }

    public async clearReviewFilters() {
        this.reviewFilter = { user_id: '', group_id: '', project_id: '' };
        this.reviewFilterSearch = { user: '', group: '', project: '' };
        this.reviewFilterOpen = { user: false, group: false, project: false };
        this.reviewPage = 1;
        await this.load('filter');
    }

    public params() {
        return {
            active_tab: this.activeTab || 'dashboard',
            user_text: this.userFilter.text || '',
            user_role: this.userFilter.role || '',
            user_active: this.userFilter.active || '',
            group_text: this.groupFilter.text || '',
            group_status: this.groupFilter.status || '',
            group_visibility: this.groupFilter.visibility || '',
            project_text: this.projectFilter.text || '',
            project_status: this.projectFilter.status || '',
            project_visibility: this.projectFilter.visibility || '',
            project_codex_status: this.projectFilter.codex_status || '',
            project_codex_account: this.projectFilter.codex_account || '',
            project_page: this.projectPage || 1,
            project_page_size: this.projectPageSize || 10,
            review_user_id: this.reviewFilter.user_id || '',
            review_group_id: this.reviewFilter.group_id || '',
            review_project_id: this.reviewFilter.project_id || '',
            dashboard_week_start: this.dashboardWeekStart || '',
            codex_request_status: this.codexRequestFilter.status || '',
            codex_request_page: this.codexRequestPage || 1,
            codex_request_page_size: this.codexRequestPageSize || 50,
            review_page: this.reviewPage || 1,
            review_page_size: this.reviewPageSize || 12,
            codex_log_error: this.codexLogFilter.error || '',
            codex_log_requester: this.codexLogFilter.requester || '',
            codex_log_account: this.codexLogFilter.account || '',
            codex_log_page: this.codexLogPage || 1,
            codex_log_page_size: this.codexLogPageSize || 20,
            codex_refresh_target: this.activeTab === 'codex' ? this.codexSubTab : '',
            system_sub_tab: this.systemSubTab || 'monitoring',
            system_traffic_period: this.systemTrafficPeriod || '24h',
            system_response_period: this.systemResponsePeriod || '3h',
            review_options: this.reviewOptionsLoaded ? '0' : '1'
        };
    }

    public applyAdminData(data: any) {
        if (data.dashboard) {
            this.dashboard = data.dashboard;
            this.dashboardWeekStart = data.dashboard.period && data.dashboard.period.start ? data.dashboard.period.start : this.dashboardWeekStart;
        }
        if (data.users !== undefined) this.users = data.users || [];
        if (data.groups !== undefined) this.groups = data.groups || [];
        if (data.projects !== undefined) this.projects = data.projects || [];
        if (data.project_total !== undefined || data.projects !== undefined) {
            this.projectTotal = Number(data.project_total === undefined ? this.projects.length : data.project_total) || 0;
        }
        if (data.project_page !== undefined) this.projectPage = Number(data.project_page) || this.projectPage;
        if (data.project_page_size !== undefined) this.projectPageSize = Number(data.project_page_size) || this.projectPageSize;
        if (data.reviews !== undefined) this.reviews = data.reviews || [];
        this.applyCodexData(data, false);
        if (data.upload_settings) this.applyUploadSettings(data.upload_settings);
        if (data.system_monitoring) {
            this.systemMonitoring = data.system_monitoring;
            const logs = data.system_monitoring.web_logs || {};
            if (logs.traffic_period) this.systemTrafficPeriod = logs.traffic_period;
            if (logs.response_period) this.systemResponsePeriod = logs.response_period;
        }
        if (data.system_cron) this.systemCron = data.system_cron;
        if (data.system_terminal_sessions) this.systemTerminalSessions = data.system_terminal_sessions;
        if (this.isReviewTab() && data.review_options) {
            this.reviewOptions = data.review_options;
            this.reviewOptionsLoaded = true;
        }
        if (data.review_total !== undefined || data.reviews !== undefined) {
            this.reviewTotal = Number(data.review_total === undefined ? this.reviews.length : data.review_total) || 0;
        }
        if (data.review_page !== undefined) this.reviewPage = Number(data.review_page) || this.reviewPage;
        if (data.review_page_size !== undefined) this.reviewPageSize = Number(data.review_page_size) || this.reviewPageSize;
        if (data.review_status_counts) {
            this.reviewStatusCounts = Object.assign(
                { open: 0, in_progress: 0, in_review: 0, resolved: 0, recheck: 0, closed: 0 },
                data.review_status_counts
            );
        } else if (data.reviews !== undefined) {
            this.calculateReviewStatusCounts();
        }
        this.syncReviewFilterSearches();
        this.ensureUserPage();
        this.ensureGroupPage();
        this.ensureProjectPage();
        this.ensureReviewPage();
    }

    private applyCodexData(data: any, resetMissing: boolean = false) {
        if (resetMissing || data.codex_accounts !== undefined) this.codexAccounts = this.codexAccountRows(data.codex_accounts || []);
        if (resetMissing || data.codex_project_groups !== undefined) this.codexProjectGroups = data.codex_project_groups || [];
        if (resetMissing || data.codex_project_total !== undefined) {
            this.codexProjectTotal = Number(data.codex_project_total === undefined ? this.codexProjectGroups.reduce((total: number, group: any) => total + Number(group.project_count || 0), 0) : data.codex_project_total) || 0;
        }
        if (resetMissing || data.codex_requests !== undefined) this.codexRequests = data.codex_requests || [];
        if (resetMissing || data.codex_request_total !== undefined) {
            this.codexRequestTotal = Number(data.codex_request_total === undefined ? this.codexRequests.length : data.codex_request_total) || 0;
        }
        if (data.codex_request_page !== undefined) this.codexRequestPage = Number(data.codex_request_page) || this.codexRequestPage;
        if (data.codex_request_page_size !== undefined) this.codexRequestPageSize = Number(data.codex_request_page_size) || this.codexRequestPageSize;
        if (resetMissing || data.codex_logs !== undefined) this.codexLogs = data.codex_logs || [];
        if (resetMissing || data.codex_log_total !== undefined) {
            this.codexLogTotal = Number(data.codex_log_total === undefined ? this.codexLogs.length : data.codex_log_total) || 0;
        }
        if (data.codex_log_page !== undefined) this.codexLogPage = Number(data.codex_log_page) || this.codexLogPage;
        if (data.codex_log_page_size !== undefined) this.codexLogPageSize = Number(data.codex_log_page_size) || this.codexLogPageSize;
        if (data.codex_log_options) this.codexLogOptions = data.codex_log_options;
        this.syncCodexLogFilterSearches();
    }

    public applyUploadSettings(settings: any) {
        const source = settings && typeof settings === 'object' ? settings : { locations: [], policies: {} };
        this.uploadSettings = source;
        const policies: any = {};
        const locations = (Array.isArray(source.locations) ? source.locations : []).map((location: any) => {
            const item = Object.assign({}, location || {});
            item.max_file_mb = Number(item.max_file_mb || 0);
            item.max_total_mb = Number(item.max_total_mb || 0);
            item.max_files = Number(item.max_files || 0);
            item.allow_all_formats = item.allow_all_formats === true;
            item.allowed_extensions = this.uploadPolicyTokenList(item.allowed_extensions, 'extension');
            item.allowed_mimes = this.uploadPolicyTokenList(item.allowed_mimes, 'mime');
            item.extension_draft = '';
            item.mime_draft = '';
            Object.assign(item, this.uploadPolicyContext(item));
            policies[item.key] = item;
            return item;
        });
        this.uploadSettingsForm = { locations, policies };
        this.uploadPolicyGroupList = this.buildUploadPolicyGroups(locations);
        this.ensureUploadCollapseState(locations);
    }

    public uploadPolicyLocations() {
        return Array.isArray(this.uploadSettingsForm.locations) ? this.uploadSettingsForm.locations : [];
    }

    private uploadPolicyContext(policy: any) {
        const key = String(policy && policy.key || '');
        const context = this.uploadPolicyContextMap[key] || {};
        const categoryKey = context.category || 'project_files';
        return {
            category_key: categoryKey,
            screen_label: context.screen || policy.section || '업로드 화면',
            target_label: context.target || policy.label || '파일 업로드',
            description: context.description || '이 위치에서 선택하는 파일 업로드 정책입니다.'
        };
    }

    private uploadPolicyCategory(categoryKey: string) {
        const fallback = {
            key: categoryKey || 'etc',
            label: '기타 업로드',
            description: '별도 분류되지 않은 업로드 설정입니다.',
            icon: 'fa-solid fa-upload'
        };
        return this.uploadPolicyCategoryMap[categoryKey] || fallback;
    }

    private ensureUploadCollapseState(locations: any[]) {
        const categoryKeys: string[] = [];
        for (const policy of locations || []) {
            const categoryKey = String(policy && policy.category_key || 'project_files');
            if (!categoryKeys.includes(categoryKey)) categoryKeys.push(categoryKey);
            if (this.uploadPolicyCollapsed[policy.key] === undefined) this.uploadPolicyCollapsed[policy.key] = true;
        }
        categoryKeys.forEach((key: string, index: number) => {
            if (this.uploadCategoryCollapsed[key] === undefined) this.uploadCategoryCollapsed[key] = index > 0;
        });
    }

    private buildUploadPolicyGroups(locations: any[]) {
        const grouped: any = {};
        for (const policy of locations || []) {
            const categoryKey = String(policy && policy.category_key || 'project_files');
            if (!grouped[categoryKey]) {
                grouped[categoryKey] = Object.assign({ policies: [] }, this.uploadPolicyCategory(categoryKey));
            }
            grouped[categoryKey].policies.push(policy);
        }
        const ordered = this.uploadPolicyCategoryOrder
            .filter((key: string) => !!grouped[key])
            .map((key: string) => grouped[key]);
        const extras = Object.keys(grouped)
            .filter((key: string) => !this.uploadPolicyCategoryOrder.includes(key))
            .map((key: string) => grouped[key]);
        return ordered.concat(extras);
    }

    public uploadPolicyGroups() {
        return Array.isArray(this.uploadPolicyGroupList) ? this.uploadPolicyGroupList : [];
    }

    private renderUploadSettingsSoon() {
        if (this.uploadSettingsRenderTimer) return;
        this.uploadSettingsRenderTimer = window.setTimeout(async () => {
            this.uploadSettingsRenderTimer = null;
            await this.service.render();
        }, 0);
    }

    public isUploadCategoryCollapsed(group: any) {
        return this.uploadCategoryCollapsed[String(group && group.key || '')] === true;
    }

    public toggleUploadCategory(group: any) {
        const key = String(group && group.key || '');
        if (!key) return;
        this.uploadCategoryCollapsed[key] = !this.isUploadCategoryCollapsed(group);
        this.renderUploadSettingsSoon();
    }

    public isUploadPolicyCollapsed(policy: any) {
        return this.uploadPolicyCollapsed[String(policy && policy.key || '')] !== false;
    }

    public toggleUploadPolicy(policy: any) {
        const key = String(policy && policy.key || '');
        if (!key) return;
        this.uploadPolicyCollapsed[key] = !this.isUploadPolicyCollapsed(policy);
        this.renderUploadSettingsSoon();
    }

    public expandAllUploadSettings() {
        for (const group of this.uploadPolicyGroups()) this.uploadCategoryCollapsed[group.key] = false;
        for (const policy of this.uploadPolicyLocations()) this.uploadPolicyCollapsed[policy.key] = false;
        this.renderUploadSettingsSoon();
    }

    public collapseAllUploadSettings() {
        for (const group of this.uploadPolicyGroups()) this.uploadCategoryCollapsed[group.key] = true;
        for (const policy of this.uploadPolicyLocations()) this.uploadPolicyCollapsed[policy.key] = true;
        this.renderUploadSettingsSoon();
    }

    public uploadPolicyUsesTotal(policy: any) {
        return ['project_document', 'review_attachment', 'activity_attachment', 'intro_attachment'].includes(String(policy && policy.key || ''));
    }

    public uploadPolicyUsesCount(policy: any) {
        return ['review_attachment', 'activity_attachment', 'intro_attachment'].includes(String(policy && policy.key || ''));
    }

    private uploadPolicyTokenList(values: any, kind: string) {
        const source = Array.isArray(values) ? values : this.splitUploadTokens(values);
        const result: string[] = [];
        const seen: any = {};
        for (const value of source) {
            const token = this.normalizeUploadToken(value, kind);
            if (!token || seen[token]) continue;
            seen[token] = true;
            result.push(token);
        }
        return result;
    }

    private splitUploadTokens(value: any) {
        return String(value || '')
            .split(/[\n\r,;\s]+/)
            .map((item: string) => item.trim())
            .filter((item: string) => !!item);
    }

    private normalizeUploadToken(value: any, kind: string) {
        let token = String(value || '').trim().toLowerCase();
        if (!token) return '';
        if (kind === 'extension') {
            token = token.replace(/^\*+/, '').replace(/[^a-z0-9._-]/g, '');
            if (!token) return '';
            if (token.charAt(0) !== '.') token = `.${token}`;
            return token === '.' ? '' : token;
        }
        token = token.replace(/\s+/g, '');
        if (token === '*') return '*/*';
        return token;
    }

    private uploadPolicyDraftKey(kind: string) {
        return kind === 'mime' ? 'mime_draft' : 'extension_draft';
    }

    private uploadPolicyListKey(kind: string) {
        return kind === 'mime' ? 'allowed_mimes' : 'allowed_extensions';
    }

    public uploadTokenDatalistId(policy: any, kind: string) {
        const key = String(policy && policy.key || 'common').replace(/[^a-z0-9_-]/gi, '-');
        return `upload-${kind}-${key}`;
    }

    public uploadTokenSuggestions(policy: any, kind: string) {
        const key = String(policy && policy.key || '');
        const mapped = this.uploadPolicySuggestionMap[key] && this.uploadPolicySuggestionMap[key][kind]
            ? this.uploadPolicySuggestionMap[key][kind]
            : [];
        const base = kind === 'mime' ? this.uploadMimeSuggestions : this.uploadExtensionSuggestions;
        return this.uploadPolicyTokenList(mapped.concat(base), kind);
    }

    public quickUploadTokenSuggestions(policy: any, kind: string) {
        const listKey = this.uploadPolicyListKey(kind);
        const existing = this.uploadPolicyTokenList(policy && policy[listKey] || [], kind);
        const existingMap: any = {};
        existing.forEach((token: string) => existingMap[token] = true);
        return this.uploadTokenSuggestions(policy, kind)
            .filter((token: string) => !existingMap[token])
            .slice(0, 8);
    }

    public uploadPolicyTokenCountLabel(policy: any, kind: string) {
        const listKey = this.uploadPolicyListKey(kind);
        const count = Array.isArray(policy && policy[listKey]) ? policy[listKey].length : 0;
        return `${count}개`;
    }

    public uploadPolicyFormatSummary(policy: any) {
        if (policy && policy.allow_all_formats) return '모든 포맷 허용';
        const extensionCount = Array.isArray(policy && policy.allowed_extensions) ? policy.allowed_extensions.length : 0;
        const mimeCount = Array.isArray(policy && policy.allowed_mimes) ? policy.allowed_mimes.length : 0;
        return `확장자 ${extensionCount}개 · MIME ${mimeCount}개`;
    }

    public uploadPolicyLimitSummary(policy: any) {
        const parts = [`파일당 ${Number(policy && policy.max_file_mb || 0)}MB`];
        if (this.uploadPolicyUsesTotal(policy)) parts.push(`총 ${Number(policy && policy.max_total_mb || 0)}MB`);
        if (this.uploadPolicyUsesCount(policy)) parts.push(`${Number(policy && policy.max_files || 0)}개`);
        return parts.join(' · ');
    }

    public addUploadPolicyToken(policy: any, kind: string, value: any = null, render: boolean = true) {
        if (!policy) return;
        const draftKey = this.uploadPolicyDraftKey(kind);
        const listKey = this.uploadPolicyListKey(kind);
        const source = value === null || value === undefined ? policy[draftKey] : value;
        const tokens = this.uploadPolicyTokenList(source, kind);
        if (!Array.isArray(policy[listKey])) policy[listKey] = [];
        const existing: any = {};
        policy[listKey].forEach((token: string) => existing[token] = true);
        for (const token of tokens) {
            if (existing[token]) continue;
            policy[listKey].push(token);
            existing[token] = true;
        }
        policy[draftKey] = '';
        if (render) this.renderUploadSettingsSoon();
    }

    public removeUploadPolicyToken(policy: any, kind: string, token: string) {
        if (!policy) return;
        const listKey = this.uploadPolicyListKey(kind);
        const normalized = this.normalizeUploadToken(token, kind);
        policy[listKey] = (Array.isArray(policy[listKey]) ? policy[listKey] : []).filter((item: string) => item !== normalized);
        this.renderUploadSettingsSoon();
    }

    public handleUploadTokenKeydown(event: any, policy: any, kind: string) {
        if (!event || !policy) return;
        const draftKey = this.uploadPolicyDraftKey(kind);
        const draft = String(policy[draftKey] || '').trim();
        if (['Enter', ',', ';'].includes(event.key)) {
            if (draft) {
                event.preventDefault();
                this.addUploadPolicyToken(policy, kind);
            }
            return;
        }
        if (event.key === 'Tab' && draft) {
            this.addUploadPolicyToken(policy, kind);
            return;
        }
        if (event.key === 'Backspace' && !draft) {
            const listKey = this.uploadPolicyListKey(kind);
            const list = Array.isArray(policy[listKey]) ? policy[listKey] : [];
            if (list.length) {
                policy[listKey] = list.slice(0, -1);
                this.renderUploadSettingsSoon();
            }
        }
    }

    public handleUploadTokenPaste(event: any, policy: any, kind: string) {
        if (!event || !event.clipboardData || !policy) return;
        const text = event.clipboardData.getData('text') || '';
        if (this.splitUploadTokens(text).length <= 1) return;
        event.preventDefault();
        this.addUploadPolicyToken(policy, kind, text);
    }

    public async saveUploadSettings() {
        if (this.savingUploadSettings) return;
        const policies: any = {};
        for (const policy of this.uploadPolicyLocations()) {
            this.addUploadPolicyToken(policy, 'extension', null, false);
            this.addUploadPolicyToken(policy, 'mime', null, false);
            policies[policy.key] = {
                max_file_mb: policy.max_file_mb,
                max_total_mb: policy.max_total_mb,
                max_files: policy.max_files,
                allow_all_formats: policy.allow_all_formats,
                allowed_extensions: this.uploadPolicyTokenList(policy.allowed_extensions, 'extension'),
                allowed_mimes: this.uploadPolicyTokenList(policy.allowed_mimes, 'mime')
            };
        }
        this.savingUploadSettings = true;
        await this.service.render();
        const { code, data } = await wiz.call('save_upload_settings', Object.assign(this.params(), {
            data: JSON.stringify({ policies })
        }));
        this.savingUploadSettings = false;
        if (code === 200) {
            this.applyAdminData(data);
            await this.service.modal.success('업로드 설정이 저장되었습니다.');
        } else {
            await this.service.modal.error(data.message || '업로드 설정을 저장하지 못했습니다.');
        }
        await this.service.render();
    }

    public async load(context: string = 'refresh', targetPage: number = 0) {
        const requestParams = this.params();
        const requestKey = JSON.stringify(requestParams);
        if (this.activeLoadPromise && this.activeLoadKey === requestKey) {
            await this.activeLoadPromise;
            return;
        }

        const generation = ++this.loadGeneration;
        this.beginLoadingTransition(context, this.activeTab, targetPage);
        await this.service.render();
        if (context === 'page') this.revealLoadingState();

        const request = (async () => {
            try {
                const { code, data } = await wiz.call('load', requestParams);
                if (generation !== this.loadGeneration) return;
                if (code === 200) {
                    this.applyAdminData(data);
                } else {
                    await this.service.modal.error(data.message || '관리자 데이터를 불러오지 못했습니다.');
                    if (code === 403) this.service.href('/projects/mine');
                }
            } catch (e) {
                if (generation !== this.loadGeneration) return;
                await this.service.modal.error('관리자 데이터를 불러오지 못했습니다.');
            } finally {
                if (generation !== this.loadGeneration) return;
                this.loading = false;
                this.loadingTargetPage = 0;
                await this.service.render();
                this.scheduleChartRender();
            }
        })();

        this.activeLoadKey = requestKey;
        this.activeLoadPromise = request;
        try {
            await request;
        } finally {
            if (this.activeLoadPromise === request) {
                this.activeLoadKey = '';
                this.activeLoadPromise = null;
            }
        }
    }

    public async saveUser(user: any) {
        this.savingUserId = user.id;
        await this.service.render();

        const payload = { id: user.id, role: user.role };
        const { code, data } = await wiz.call('save_user', Object.assign(this.params(), { data: JSON.stringify(payload) }));
        this.savingUserId = '';
        if (code === 200) {
            this.applyAdminData(data);
            await this.service.modal.success('사용자 권한이 저장되었습니다.');
        } else {
            await this.service.modal.error(data.message || '사용자 권한을 저장하지 못했습니다.');
        }
        await this.service.render();
    }

    public userLabel(user: any) {
        return user?.display_name || user?.name || user?.email || '사용자';
    }

    public signupPurpose(user: any) {
        return String(user?.signup_purpose || '').trim();
    }

    public async viewSignupPurpose(user: any) {
        const purpose = this.signupPurpose(user) || '작성된 가입 목적이 없습니다.';
        await this.service.modal.show({
            title: '가입 목적',
            message: `${this.userLabel(user)}\n${user?.email || '-'}\n\n${purpose}`,
            action: '확인',
            cancel: false,
            status: 'success',
            actionBtn: 'success'
        });
    }

    public async approveUser(user: any) {
        const purpose = this.signupPurpose(user) || '작성된 가입 목적이 없습니다.';
        const ok = await this.service.modal.show({
            title: '가입 승인',
            message: `${this.userLabel(user)}\n${user?.email || '-'}\n\n가입 목적\n${purpose}\n\n이 사용자의 가입을 승인할까요?`,
            action: '승인',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!ok) return;
        this.approvingUserId = user.id;
        await this.service.render();

        const payload = { id: user.id };
        const { code, data } = await wiz.call('approve_user', Object.assign(this.params(), { data: JSON.stringify(payload) }));
        this.approvingUserId = '';
        if (code === 200) {
            this.applyAdminData(data);
            await this.service.modal.success('사용자 가입을 승인했습니다.');
        } else {
            await this.service.modal.error(data.message || '사용자 가입을 승인하지 못했습니다.');
        }
        await this.service.render();
    }

    public dashboardUserId(user: any) {
        return String((user && (user.id || user.user_id)) || '').trim();
    }

    public async openUserDashboard(user: any) {
        const userId = this.dashboardUserId(user);
        if (!userId) return;
        this.selectedDashboardUser = Object.assign({}, user, {
            id: userId,
            display_name: (user && (user.display_name || user.label || user.name || user.email)) || userId,
            name: (user && (user.name || user.label || user.display_name || user.email)) || userId,
            email: (user && user.email) || '',
            role: (user && user.role) || ''
        });
        this.userActivityWeekStart = '';
        this.userDashboardOpen = true;
        await this.loadUserDashboard();
    }

    public async loadUserDashboard() {
        const userId = this.dashboardUserId(this.selectedDashboardUser);
        if (!userId) return;
        this.userDashboardLoading = true;
        await this.service.render();

        const { code, data } = await wiz.call('load_user_activity_dashboard', {
            user_id: userId,
            user_activity_week_start: this.userActivityWeekStart || ''
        });
        if (code === 200) {
            this.userActivityDashboard = data.dashboard || this.userActivityDashboard;
            this.userActivityWeekStart = this.userActivityDashboard.period && this.userActivityDashboard.period.start
                ? this.userActivityDashboard.period.start
                : this.userActivityWeekStart;
        } else {
            this.userDashboardOpen = false;
            await this.service.modal.error(data.message || '사용자 활동 정보를 불러오지 못했습니다.');
        }

        this.userDashboardLoading = false;
        await this.service.render();
        this.scheduleChartRender();
    }

    public async closeUserDashboard() {
        this.userDashboardOpen = false;
        this.userDashboardLoading = false;
        this.selectedDashboardUser = null;
        await this.service.render();
        this.destroyCharts('user');
    }

    public async openUserActivityGuide() {
        this.userActivityGuideOpen = true;
        await this.service.render();
    }

    public async closeUserActivityGuide() {
        this.userActivityGuideOpen = false;
        await this.service.render();
    }

    public async moveUserDashboardWeek(direction: number) {
        const period = this.userActivityDashboard && this.userActivityDashboard.period ? this.userActivityDashboard.period : {};
        this.userActivityWeekStart = direction < 0 ? (period.previous_start || '') : (period.next_start || '');
        await this.loadUserDashboard();
    }

    public async resetUserDashboardWeek() {
        this.userActivityWeekStart = '';
        await this.loadUserDashboard();
    }

    public userActivityHistoryExportUrl() {
        const params = new URLSearchParams();
        params.set('user_id', this.dashboardUserId(this.selectedDashboardUser));
        if (this.userActivityWeekStart) params.set('user_activity_week_start', this.userActivityWeekStart);
        return `/wiz/api/page.admin/export_user_activity_history?${params.toString()}`;
    }

    public userActivityHistoryExportFileName() {
        const period = this.userActivityDashboard && this.userActivityDashboard.period ? this.userActivityDashboard.period : {};
        const start = String(period.start || this.userActivityWeekStart || '').replace(/[^\d]+/g, '');
        const end = String(period.end || '').replace(/[^\d]+/g, '');
        const source = this.selectedDashboardUser || {};
        const userName = String(source.display_name || source.name || source.email || 'user').replace(/[\\/:*?"<>|]+/g, '-');
        return `${userName}-activity-history-${start || 'start'}-${end || 'end'}.xlsx`;
    }

    public userActivityExportResponseFileName(response: any) {
        const fallback = this.userActivityHistoryExportFileName();
        const header = String(response && response.headers ? response.headers.get('content-disposition') || '' : '');
        const encoded = /filename\*=UTF-8''([^;]+)/i.exec(header);
        if (encoded && encoded[1]) {
            try {
                return decodeURIComponent(encoded[1].replace(/"/g, '')).replace(/[\\/:*?"<>|]+/g, '-');
            } catch (e) { }
        }
        const quoted = /filename="?([^";]+)"?/i.exec(header);
        return String((quoted && quoted[1]) || fallback).replace(/[\\/:*?"<>|]+/g, '-');
    }

    public async exportUserActivityHistory() {
        if (this.userActivityExporting || this.userDashboardLoading || !this.dashboardUserId(this.selectedDashboardUser)) return;
        this.userActivityExporting = true;
        await this.service.render();
        try {
            const response = await fetch(this.userActivityHistoryExportUrl(), { credentials: 'same-origin' });
            const contentType = String(response.headers.get('content-type') || '').toLowerCase();
            if (!response.ok || contentType.includes('application/json')) {
                let message = '사용자 활동 이력 Excel을 생성하지 못했습니다.';
                try {
                    const payload = await response.json();
                    message = (payload && payload.data && payload.data.message) || payload.message || message;
                } catch (e) { }
                await this.service.modal.error(message);
                return;
            }
            const blob = await response.blob();
            if (!blob || blob.size <= 0) {
                await this.service.modal.error('다운로드할 사용자 활동 이력 파일이 없습니다.');
                return;
            }
            const objectUrl = window.URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = objectUrl;
            anchor.download = this.userActivityExportResponseFileName(response);
            document.body.appendChild(anchor);
            anchor.click();
            anchor.remove();
            window.setTimeout(() => window.URL.revokeObjectURL(objectUrl), 1000);
        } catch (e) {
            await this.service.modal.error('사용자 활동 이력 Excel을 생성하지 못했습니다.');
        } finally {
            this.userActivityExporting = false;
            await this.service.render();
        }
    }

    public async restoreGroup(group: any) {
        if (!group || group.status !== 'deleted') return;
        const ok = await this.service.modal.show({
            title: '그룹 복원',
            message: `${group.name} 그룹을 활성 상태로 복원할까요?`,
            action: '복원',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!ok) return;
        this.restoringGroupId = group.id;
        await this.service.render();
        const { code, data } = await wiz.call('restore_group', Object.assign(this.params(), {
            data: JSON.stringify({ id: group.id })
        }));
        this.restoringGroupId = '';
        if (code === 200) {
            this.applyAdminData(data);
            await this.service.modal.success('그룹을 복원했습니다.');
        } else {
            await this.service.modal.error(data.message || '그룹을 복원하지 못했습니다.');
        }
        await this.service.render();
    }

    public roleLabel(role: string) {
        const labels: any = { admin: '관리자', internal: '내부사용자', user: '사용자', guest: '손님' };
        return labels[role || 'user'] || role;
    }

    public projectRoleLabel(role: string) {
        const labels: any = { owner: '소유자', developer: '관리자', admin: '관리자', reviewer: '리뷰어', guest: '게스트' };
        return labels[role || 'reviewer'] || role;
    }

    public statusLabel(status: string) {
        const labels: any = { active: '활성', disabled: '비활성', archived: '보관', deleted: '삭제' };
        return labels[status || 'active'] || status;
    }

    public visibilityLabel(visibility: string) {
        const labels: any = { organization: '공개', public: '공개', private: '비공개' };
        return labels[visibility || 'public'] || visibility;
    }

    public kstDateTime(value: any) {
        return this.service.formatter.kstDateTime(value, '-');
    }

    public systemStorage() {
        return this.systemMonitoring && this.systemMonitoring.storage ? this.systemMonitoring.storage : {};
    }

    public systemWebLogs() {
        return this.systemMonitoring && this.systemMonitoring.web_logs ? this.systemMonitoring.web_logs : {};
    }

    public systemTrafficPeriodTabs() {
        return [
            { key: '7d', label: '최근 7일', scale: '1시간' },
            { key: '3d', label: '최근 3일', scale: '1시간' },
            { key: '24h', label: '최근 24시간', scale: '10분' },
            { key: '12h', label: '최근 12시간', scale: '10분' }
        ];
    }

    public systemTrafficPeriodTabClass(key: string) {
        const base = 'inline-flex h-7 items-center rounded-md px-2.5 text-[11px] font-semibold';
        return this.systemTrafficPeriod === key
            ? `${base} bg-slate-900 text-white`
            : `${base} text-slate-500 hover:bg-slate-100 hover:text-slate-900`;
    }

    public async setSystemTrafficPeriod(key: string) {
        if (!this.systemTrafficPeriodTabs().some((tab: any) => tab.key === key) || this.systemTrafficPeriod === key || this.systemMonitoringRefreshing) return;
        this.systemTrafficPeriod = key;
        await this.service.render();
        await this.refreshSystemMonitoring('traffic');
    }

    public systemResponsePeriodOptions() {
        return [
            { key: '7d', label: '최근 7일' },
            { key: '3d', label: '최근 3일' },
            { key: '24h', label: '최근 24시간' },
            { key: '12h', label: '최근 12시간' },
            { key: '6h', label: '최근 6시간' },
            { key: '3h', label: '최근 3시간' },
            { key: '1h', label: '최근 1시간' }
        ];
    }

    public async setSystemResponsePeriod(key: string) {
        if (!this.systemResponsePeriodOptions().some((option: any) => option.key === key) || this.systemMonitoringRefreshing) return;
        this.systemResponsePeriod = key;
        this.systemResponseLogLoading = true;
        if (this.systemLogChartModal.open) {
            this.systemLogChartModal.open = false;
            this.systemLogChartModal.row = null;
            this.destroyCharts('systemLog');
        }
        await this.service.render();
        await this.refreshSystemMonitoring('response');
    }

    public systemTrafficSummary() {
        return this.systemWebLogs().traffic_chart || this.systemWebLogs().traffic_10m || { buckets: [], total_count: 0, peak_count: 0, bucket_label: '10분', period_label: '최근 24시간 · 10분 단위 · UTC+9 기준' };
    }

    public systemTrafficBuckets() {
        const rows = this.systemTrafficSummary().buckets || [];
        return Array.isArray(rows) ? rows : [];
    }

    public systemTrafficChartEmpty() {
        return this.systemTrafficBuckets().reduce((total: number, row: any) => total + Number(row && row.count || 0), 0) <= 0;
    }

    public systemCronJobs() {
        const rows = this.systemCron && this.systemCron.jobs ? this.systemCron.jobs : [];
        return Array.isArray(rows) ? rows : [];
    }

    public systemTerminalRows() {
        const rows = this.systemTerminalSessions && this.systemTerminalSessions.rows ? this.systemTerminalSessions.rows : [];
        return Array.isArray(rows) ? rows : [];
    }

    public systemTerminalWorkers() {
        const rows = this.systemTerminalSessions && this.systemTerminalSessions.workers ? this.systemTerminalSessions.workers : [];
        return Array.isArray(rows) ? rows : [];
    }

    public systemTerminalStatusBadgeClass(row: any) {
        const status = String(row && row.status || '');
        if (status === 'active') return 'inline-flex shrink-0 items-center whitespace-nowrap rounded-full bg-emerald-50 px-2.5 py-1 text-[11px] font-semibold text-emerald-700';
        if (status === 'stale') return 'inline-flex shrink-0 items-center whitespace-nowrap rounded-full bg-amber-50 px-2.5 py-1 text-[11px] font-semibold text-amber-700';
        return 'inline-flex shrink-0 items-center whitespace-nowrap rounded-full bg-slate-100 px-2.5 py-1 text-[11px] font-semibold text-slate-500';
    }

    public systemTerminalTypeBadgeClass(row: any) {
        const type = String(row && row.terminal_type || '');
        if (type === 'admin') return 'inline-flex shrink-0 items-center whitespace-nowrap rounded-full bg-violet-50 px-2.5 py-1 text-[11px] font-semibold text-violet-700';
        if (type === 'codex_login_request') return 'inline-flex shrink-0 items-center whitespace-nowrap rounded-full bg-blue-50 px-2.5 py-1 text-[11px] font-semibold text-blue-700';
        return 'inline-flex shrink-0 items-center whitespace-nowrap rounded-full bg-slate-100 px-2.5 py-1 text-[11px] font-semibold text-slate-600';
    }

    public systemTerminalSyncLabel() {
        const data = this.systemTerminalSessions || {};
        const workerCount = Number(data.worker_count || 0);
        const threshold = Number(data.stale_threshold_seconds || 0);
        return `워커 ${this.systemMonitoringMetric(workerCount)}개 · ${threshold}초 heartbeat 기준`;
    }

    public systemCronServiceLabel() {
        const service = this.systemCron && this.systemCron.service ? this.systemCron.service : {};
        if (service.running) return `${service.name || 'cron'} 실행 중`;
        if (service.name) return `${service.name} 중지`;
        return service.message || '서비스 확인 불가';
    }

    public systemCronServiceBadgeClass() {
        const service = this.systemCron && this.systemCron.service ? this.systemCron.service : {};
        if (service.running) return 'inline-flex shrink-0 items-center whitespace-nowrap rounded-full bg-emerald-50 px-2.5 py-1 text-[11px] font-semibold text-emerald-700';
        return 'inline-flex shrink-0 items-center whitespace-nowrap rounded-full bg-rose-50 px-2.5 py-1 text-[11px] font-semibold text-rose-700';
    }

    public systemCronStatusBadgeClass(job: any) {
        const status = String(job && job.status || '');
        if (status === 'ok') return 'inline-flex shrink-0 items-center whitespace-nowrap rounded-full bg-emerald-50 px-2.5 py-1 text-[11px] font-semibold text-emerald-700';
        if (status === 'missing') return 'inline-flex shrink-0 items-center whitespace-nowrap rounded-full bg-rose-50 px-2.5 py-1 text-[11px] font-semibold text-rose-700';
        return 'inline-flex shrink-0 items-center whitespace-nowrap rounded-full bg-amber-50 px-2.5 py-1 text-[11px] font-semibold text-amber-700';
    }

    public canInstallSystemCron(job: any) {
        if (!job || !job.key) return false;
        return this.systemCron && this.systemCron.crontab_available && !this.systemCron.crontab_error && job.status !== 'ok';
    }

    public systemLogRows(kind: string) {
        const logs = this.systemWebLogs();
        const rows = logs && logs[kind] ? logs[kind] : [];
        return Array.isArray(rows) ? rows : [];
    }

    public systemResponseLogTabs() {
        return [
            { key: 'top_average', label: '평균응답지연' },
            { key: 'top_max', label: '최대응답지연' },
            { key: 'recent_slow', label: '고지연로그' },
            { key: 'top_errors', label: '응답오류' }
        ];
    }

    public systemResponseLogTabClass(tab: string) {
        const base = 'inline-flex h-7 items-center rounded-md px-2.5 text-[11px] font-semibold';
        return this.systemResponseLogTab === tab
            ? `${base} bg-slate-900 text-white`
            : `${base} text-slate-500 hover:bg-slate-100 hover:text-slate-900`;
    }

    public systemResponseLogTitle() {
        const active = this.systemResponseLogTabs().find((tab: any) => tab.key === this.systemResponseLogTab);
        return active ? active.label : '평균응답지연';
    }

    public systemResponsePeriodLabel(key: string = '') {
        const target = key || this.systemResponsePeriod || '3h';
        const active = this.systemResponsePeriodOptions().find((option: any) => option.key === target);
        return active ? active.label : '최근 3시간';
    }

    public systemResponseLogPeriodLabel() {
        const logs = this.systemWebLogs();
        const selected = this.systemResponsePeriodLabel();
        const timezone = logs.timezone || 'UTC+9';
        if (this.systemResponseLogLoading) return `${selected} 통계를 불러오는 중`;
        if (logs.response_period === this.systemResponsePeriod && logs.period_label) return logs.period_label;
        return `${selected} DB 통계 · ${timezone} 기준`;
    }

    public systemResponseLogDescription() {
        const descriptions: any = {
            top_average: 'DB에 적재된 ReviewOps endpoint별 평균 응답시간 기준입니다.',
            top_max: 'DB에 적재된 ReviewOps endpoint별 최대 응답시간 기준입니다.',
            recent_slow: 'DB에 적재된 ReviewOps 집계 구간별 최대 응답시간 기준입니다.',
            top_errors: 'DB에 적재된 ReviewOps 4xx/5xx 또는 오류 로그가 많은 endpoint 기준입니다.'
        };
        const description = descriptions[this.systemResponseLogTab] || '';
        const period = this.systemResponseLogPeriodLabel();
        return period ? `${description} · ${period}` : description;
    }

    public systemResponseLogRows() {
        return this.systemLogRows(this.systemResponseLogTab || 'top_average');
    }

    public isSystemRecentSlowTab() {
        return this.systemResponseLogTab === 'recent_slow';
    }

    public isSystemErrorTab() {
        return this.systemResponseLogTab === 'top_errors';
    }

    public systemStorageChildren() {
        const rows = this.systemStorage().top_children || [];
        return Array.isArray(rows) ? rows : [];
    }

    public systemLogSources() {
        const rows = this.systemWebLogs().sources || [];
        return Array.isArray(rows) ? rows : [];
    }

    public systemPercentWidth(value: any) {
        const percent = Math.max(0, Math.min(100, Number(value || 0)));
        return `${percent}%`;
    }

    public systemMonitoringMetric(value: any) {
        return this.dashboardCount(value);
    }

    public systemLatencyLabel(row: any, field: string) {
        if (!row) return '-';
        if (field === 'average') return row.average_label || this.formatSystemMs(row.average_ms);
        if (field === 'max') return row.max_label || this.formatSystemMs(row.max_ms);
        return row.duration_label || this.formatSystemMs(row.duration_ms);
    }

    public formatSystemMs(value: any) {
        const ms = Math.max(0, Number(value || 0));
        if (ms >= 1000) return `${(ms / 1000).toFixed(2).replace(/\.00$/, '')}s`;
        return `${Math.round(ms)}ms`;
    }

    public systemRowStatus(row: any) {
        return row && row.status_summary ? row.status_summary : '-';
    }

    public systemErrorRate(row: any) {
        const value = Number(row && row.error_rate || 0);
        return `${value.toFixed(1).replace(/\.0$/, '')}%`;
    }

    public systemLogChartSubtitle() {
        const logs = this.systemWebLogs();
        const period = logs.period_start && logs.period_end ? `${logs.period_start} ~ ${logs.period_end}` : (logs.period_label || '최근 3일');
        const row = this.systemLogChartModal.row || {};
        const endpoint = row.endpoint ? `${row.method || '-'} ${row.endpoint}` : '';
        return endpoint ? `${endpoint} · ${period} · ${logs.timezone || 'UTC+9'} 기준` : `${period} · ${logs.timezone || 'UTC+9'} 기준`;
    }

    public systemLogDurationHistogram() {
        const row = this.systemLogChartModal.row || {};
        const rows = row.duration_histogram || [];
        return Array.isArray(rows) ? rows : [];
    }

    public systemLogHourlyErrors() {
        const row = this.systemLogChartModal.row || {};
        const rows = row.hourly_errors || [];
        return Array.isArray(rows) ? rows : [];
    }

    public systemLogChartRows() {
        return this.systemLogChartModal.type === 'errors'
            ? this.systemLogHourlyErrors()
            : this.systemLogDurationHistogram();
    }

    public systemLogChartEmpty() {
        return this.systemLogChartRows().reduce((total: number, row: any) => total + Number(row && row.count || 0), 0) <= 0;
    }

    public async openSystemLogChart(row: any) {
        if (!row || !row.endpoint) return;
        const isErrors = this.isSystemErrorTab();
        const requestKey = `${Date.now()}-${row.method || ''}-${row.endpoint}`;
        this.systemLogChartModal = {
            open: true,
            type: isErrors ? 'errors' : 'duration',
            title: isErrors ? '오류 로그 시간대별 현황' : '응답시간 분포',
            subtitle: '',
            row: Object.assign({}, row, { duration_histogram: [], hourly_errors: [] }),
            loading: true,
            requestKey: requestKey
        };
        await this.service.render();
        try {
            const { code, data } = await wiz.call('load_system_log_chart', Object.assign(this.params(), {
                data: JSON.stringify({
                    response_period: this.systemResponsePeriod,
                    method: row.method || '',
                    endpoint: row.endpoint
                })
            }));
            if (!this.systemLogChartModal.open || this.systemLogChartModal.requestKey !== requestKey) return;
            if (code !== 200) {
                await this.service.modal.error((data && data.message) || '응답 로그 차트를 불러오지 못했습니다.');
                return;
            }
            this.systemLogChartModal.row = Object.assign({}, this.systemLogChartModal.row, data && data.chart || {});
        } catch (e) {
            if (this.systemLogChartModal.open && this.systemLogChartModal.requestKey === requestKey) {
                await this.service.modal.error('응답 로그 차트를 불러오지 못했습니다.');
            }
        } finally {
            if (this.systemLogChartModal.open && this.systemLogChartModal.requestKey === requestKey) {
                this.systemLogChartModal.loading = false;
                await this.service.render();
                this.scheduleChartRender();
            }
        }
    }

    public async closeSystemLogChart() {
        this.systemLogChartModal.open = false;
        this.systemLogChartModal.row = null;
        this.systemLogChartModal.requestKey = '';
        this.destroyCharts('systemLog');
        await this.service.render();
    }

    public visibilityBadgeClass(visibility: string) {
        if (visibility === 'private') return 'inline-flex shrink-0 whitespace-nowrap rounded-full bg-slate-900 px-2 py-0.5 text-[11px] font-medium text-white';
        return 'inline-flex shrink-0 whitespace-nowrap rounded-full bg-emerald-50 px-2 py-0.5 text-[11px] font-medium text-emerald-700';
    }

    public statusBadgeClass(status: string) {
        if (status === 'deleted') return 'inline-flex shrink-0 whitespace-nowrap rounded-full bg-rose-50 px-2 py-0.5 text-[11px] font-medium text-rose-700';
        if (status === 'archived') return 'inline-flex shrink-0 whitespace-nowrap rounded-full bg-amber-50 px-2 py-0.5 text-[11px] font-medium text-amber-700';
        if (status === 'disabled') return 'inline-flex shrink-0 whitespace-nowrap rounded-full bg-slate-200 px-2 py-0.5 text-[11px] font-medium text-slate-600';
        return 'inline-flex shrink-0 whitespace-nowrap rounded-full bg-emerald-50 px-2 py-0.5 text-[11px] font-medium text-emerald-700';
    }

    public groupPath(group: any) {
        return `/projects/mine/group/${group && group.id ? group.id : ''}`;
    }

    public projectPath(project: any, tab: string = '') {
        const id = project && project.id ? project.id : '';
        if (!id) return '/projects';
        return tab === 'review' ? `/projects/${id}/review` : `/projects/${id}`;
    }

    public adminQueryParams() {
        return { admin: '1' };
    }

    public normalizeReviewAxisFilter() {
        return;
    }

    public reviewFilterKey(kind: string) {
        if (kind === 'user') return 'user_id';
        if (kind === 'group') return 'group_id';
        return 'project_id';
    }

    public reviewFilterOptionLabel(kind: string, option: any) {
        if (!option) return '';
        if (kind === 'user') {
            const name = option.name || option.email || '작성자';
            return option.email && option.email !== name ? `${name} · ${option.email}` : name;
        }
        if (kind === 'group') return option.name || '그룹';
        const name = option.name || '프로젝트';
        const groupName = option.group && option.group.name ? option.group.name : '';
        return groupName ? `${name} · ${groupName}` : name;
    }

    public selectedReviewFilterOption(kind: string) {
        const key = this.reviewFilterKey(kind);
        const value = String(this.reviewFilter[key] || '');
        if (!value) return null;
        const options = kind === 'user'
            ? this.reviewUserOptions()
            : kind === 'group'
                ? this.reviewGroupOptions()
                : this.reviewProjectOptions();
        return options.find((option: any) => option && option.id === value) || null;
    }

    public syncReviewFilterSearch(kind: string) {
        const selected = this.selectedReviewFilterOption(kind);
        this.reviewFilterSearch[kind] = selected ? this.reviewFilterOptionLabel(kind, selected) : '';
    }

    public syncReviewFilterSearches() {
        this.syncReviewFilterSearch('user');
        this.syncReviewFilterSearch('group');
        this.syncReviewFilterSearch('project');
    }

    public openReviewFilterPicker(kind: string) {
        this.reviewFilterOpen[kind] = true;
        this.service.render();
    }

    public reviewFilterPickerInput(kind: string) {
        this.reviewFilterOpen[kind] = true;
        this.service.render();
    }

    public closeReviewFilterPickerLater(kind: string) {
        window.setTimeout(async () => {
            this.reviewFilterOpen[kind] = false;
            this.syncReviewFilterSearch(kind);
            await this.service.render();
        }, 120);
    }

    public filteredReviewFilterOptions(kind: string) {
        const query = String(this.reviewFilterSearch[kind] || '').trim().toLowerCase();
        const options = kind === 'user'
            ? this.reviewUserOptions()
            : kind === 'group'
                ? this.reviewGroupOptions()
                : this.reviewProjectOptions();
        return options.filter((option: any) => {
            const label = this.reviewFilterOptionLabel(kind, option).toLowerCase();
            return !query || label.includes(query);
        }).slice(0, 50);
    }

    public async selectReviewFilterOption(kind: string, option: any) {
        if (!option || !option.id) return;
        const key = this.reviewFilterKey(kind);
        this.reviewFilter[key] = option.id;
        this.reviewFilterSearch[kind] = this.reviewFilterOptionLabel(kind, option);
        this.reviewFilterOpen[kind] = false;
        await this.searchReviews();
    }

    public async selectFirstReviewFilterOption(kind: string) {
        const options = this.filteredReviewFilterOptions(kind);
        if (options.length) await this.selectReviewFilterOption(kind, options[0]);
    }

    public async clearReviewFilter(kind: string) {
        const key = this.reviewFilterKey(kind);
        this.reviewFilter[key] = '';
        this.reviewFilterSearch[kind] = '';
        this.reviewFilterOpen[kind] = false;
        await this.searchReviews();
    }

    public visibleUsers() {
        const start = (this.userPage - 1) * this.userPageSize;
        return this.users.slice(start, start + this.userPageSize);
    }

    public userTotalPages() {
        const total = Math.ceil(this.users.length / this.userPageSize);
        return Math.max(total || 1, 1);
    }

    public userPageStart() {
        if (!this.users.length) return 0;
        return (this.userPage - 1) * this.userPageSize + 1;
    }

    public userPageEnd() {
        return Math.min(this.userPage * this.userPageSize, this.users.length);
    }

    public userPageNumbers() {
        return this.pageNumbers(this.userPage, this.userTotalPages());
    }

    public setUserPage(page: number) {
        const next = this.clampPage(page, this.userTotalPages());
        if (this.userPage === next) return;
        this.userPage = next;
        this.service.render();
    }

    public ensureUserPage() {
        this.setUserPage(this.userPage);
    }

    public visibleGroups() {
        const start = (this.groupPage - 1) * this.groupPageSize;
        return this.groups.slice(start, start + this.groupPageSize);
    }

    public groupTotalPages() {
        const total = Math.ceil(this.groups.length / this.groupPageSize);
        return Math.max(total || 1, 1);
    }

    public groupPageStart() {
        if (!this.groups.length) return 0;
        return (this.groupPage - 1) * this.groupPageSize + 1;
    }

    public groupPageEnd() {
        return Math.min(this.groupPage * this.groupPageSize, this.groups.length);
    }

    public groupPageNumbers() {
        return this.pageNumbers(this.groupPage, this.groupTotalPages());
    }

    public setGroupPage(page: number) {
        const next = this.clampPage(page, this.groupTotalPages());
        if (this.groupPage === next) return;
        this.groupPage = next;
        this.service.render();
    }

    public ensureGroupPage() {
        this.setGroupPage(this.groupPage);
    }

    public visibleProjects() {
        return this.projects;
    }

    public projectTotalPages() {
        const total = Math.ceil(this.projectTotal / this.projectPageSize);
        return Math.max(total || 1, 1);
    }

    public projectPageStart() {
        if (!this.projectTotal) return 0;
        return (this.projectPage - 1) * this.projectPageSize + 1;
    }

    public projectPageEnd() {
        return Math.min(this.projectPage * this.projectPageSize, this.projectTotal);
    }

    public projectPageNumbers() {
        return this.pageNumbers(this.projectPage, this.projectTotalPages());
    }

    public async setProjectPage(page: number) {
        const next = this.clampPage(page, this.projectTotalPages());
        if (this.projectPage === next) return;
        this.projectPage = next;
        await this.load('page', next);
    }

    public ensureProjectPage() {
        this.projectPage = this.clampPage(this.projectPage, this.projectTotalPages());
    }

    public visibleReviews() {
        return this.reviews;
    }

    public reviewTotalPages() {
        const total = Math.ceil(this.reviewTotal / this.reviewPageSize);
        return Math.max(total || 1, 1);
    }

    public reviewPageStart() {
        if (!this.reviewTotal) return 0;
        return (this.reviewPage - 1) * this.reviewPageSize + 1;
    }

    public reviewPageEnd() {
        return Math.min(this.reviewPage * this.reviewPageSize, this.reviewTotal);
    }

    public reviewPageNumbers() {
        return this.pageNumbers(this.reviewPage, this.reviewTotalPages());
    }

    public async setReviewPage(page: number) {
        const next = this.clampPage(page, this.reviewTotalPages());
        if (this.reviewPage === next) return;
        this.reviewPage = next;
        await this.load('page', next);
    }

    public ensureReviewPage() {
        this.reviewPage = this.clampPage(this.reviewPage, this.reviewTotalPages());
    }

    public codexRequestTotalPages() {
        const total = Math.ceil(this.codexRequestTotal / this.codexRequestPageSize);
        return Math.max(total || 1, 1);
    }

    public codexRequestPageStart() {
        if (!this.codexRequestTotal) return 0;
        return (this.codexRequestPage - 1) * this.codexRequestPageSize + 1;
    }

    public codexRequestPageEnd() {
        return Math.min(this.codexRequestPage * this.codexRequestPageSize, this.codexRequestTotal);
    }

    public codexRequestPageNumbers() {
        return this.pageNumbers(this.codexRequestPage, this.codexRequestTotalPages());
    }

    public async setCodexRequestPage(page: number) {
        const next = this.clampPage(page, this.codexRequestTotalPages());
        if (this.codexRequestPage === next) return;
        this.codexRequestPage = next;
        await this.load('page', next);
    }

    public codexLogTotalPages() {
        const total = Math.ceil(this.codexLogTotal / this.codexLogPageSize);
        return Math.max(total || 1, 1);
    }

    public codexLogPageStart() {
        if (!this.codexLogTotal) return 0;
        return (this.codexLogPage - 1) * this.codexLogPageSize + 1;
    }

    public codexLogPageEnd() {
        return Math.min(this.codexLogPage * this.codexLogPageSize, this.codexLogTotal);
    }

    public codexLogPageNumbers() {
        return this.pageNumbers(this.codexLogPage, this.codexLogTotalPages());
    }

    public async setCodexLogPage(page: number) {
        const next = this.clampPage(page, this.codexLogTotalPages());
        if (this.codexLogPage === next) return;
        this.codexLogPage = next;
        await this.load('page', next);
    }

    public pageNumbers(currentPage: number, totalPages: number) {
        const total = Math.max(Number(totalPages) || 1, 1);
        const current = Math.min(Math.max(Number(currentPage) || 1, 1), total);
        const start = Math.max(1, Math.min(current - 2, total - 4));
        const end = Math.min(total, start + 4);
        const pages: number[] = [];
        for (let page = start; page <= end; page++) pages.push(page);
        return pages;
    }

    private clampPage(page: number, totalPages: number) {
        const total = Math.max(Number(totalPages) || 1, 1);
        return Math.min(Math.max(Number(page) || 1, 1), total);
    }

    public activeLabel(user: any) {
        return user?.account_status_label || (user?.is_active ? '승인됨' : '승인 대기');
    }

    public accountStatusClass(user: any) {
        const status = user?.account_status || (user?.is_active ? 'approved' : 'pending');
        if (status === 'approved') return 'inline-flex shrink-0 whitespace-nowrap rounded-full bg-emerald-50 px-2 py-1 text-[11px] font-medium text-emerald-700';
        if (status === 'pending') return 'inline-flex shrink-0 whitespace-nowrap rounded-full bg-amber-50 px-2 py-1 text-[11px] font-medium text-amber-700';
        return 'inline-flex shrink-0 whitespace-nowrap rounded-full bg-slate-100 px-2 py-1 text-[11px] font-medium text-slate-500';
    }

    public reviewSummaryCount(summary: any, status: string) {
        if (status === 'total') return Number(summary && summary.total) || 0;
        const byStatus = summary && summary.by_status ? summary.by_status : {};
        return Number(byStatus && byStatus[status]) || 0;
    }

    public reviewSummaryTileClass(summary: any, status: string, activeBg: string, extra: string = '') {
        const base = `${extra ? `${extra} ` : ''}rounded-md px-1.5 py-1.5`;
        return `${base} ${this.reviewSummaryCount(summary, status) > 0 ? activeBg : 'bg-slate-50'}`;
    }

    public reviewSummaryLabelClass(summary: any, status: string, activeText: string, size: string = 'text-[10px]') {
        return `${size} ${this.reviewSummaryCount(summary, status) > 0 ? activeText : 'text-slate-300'}`;
    }

    public reviewSummaryCountClass(summary: any, status: string, activeText: string) {
        return `text-[13px] font-semibold ${this.reviewSummaryCount(summary, status) > 0 ? activeText : 'text-slate-300'}`;
    }

    public calculateReviewStatusCounts() {
        const counts: any = { open: 0, in_progress: 0, in_review: 0, resolved: 0, recheck: 0, closed: 0 };
        for (const review of this.reviews) {
            const status = review && review.status ? review.status : 'open';
            if (counts[status] === undefined) counts[status] = 0;
            counts[status] += 1;
        }
        this.reviewStatusCounts = counts;
    }

    public reviewStatusLabel(value: string) {
        const option = this.reviewStatusOptions.find((item) => item.value === value);
        return option ? option.label : value;
    }

    public reviewStatusBadgeClass(value: string) {
        const status = value || 'open';
        const base = 'inline-flex shrink-0 whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-medium ';
        if (status === 'resolved') return base + 'bg-emerald-50 text-emerald-700';
        if (status === 'closed') return base + 'bg-slate-100 text-slate-700';
        if (status === 'in_review') return base + 'bg-indigo-50 text-indigo-700';
        if (status === 'in_progress') return base + 'bg-amber-50 text-amber-700';
        if (status === 'recheck') return base + 'bg-rose-50 text-rose-700';
        return base + 'bg-rose-50 text-rose-700';
    }

    public priorityLabel(value: string) {
        const labels: any = { low: '낮음', normal: '보통', high: '높음', critical: '긴급' };
        return labels[value || 'normal'] || value;
    }

    public categoryLabel(value: string) {
        const labels: any = {
            bug: '버그',
            ux: 'UX',
            content: '콘텐츠',
            performance: '성능',
            accessibility: '접근성',
            security: '보안',
            structure: '구조',
            design: '설계',
            data: '데이터',
            message: '메시지',
            typo: '오탈자',
            other: '기타'
        };
        return labels[value || 'other'] || value;
    }

    public reviewProject(review: any) {
        return review && review.project ? review.project : {};
    }

    public reviewGroup(review: any) {
        const project = this.reviewProject(review);
        return (review && review.group) || (project && project.group) || {};
    }

    public reviewProjectName(review: any) {
        const project = this.reviewProject(review);
        return project && project.name ? project.name : '-';
    }

    public reviewGroupName(review: any) {
        const group = this.reviewGroup(review);
        return group && group.name ? group.name : '-';
    }

    public reviewAuthorName(review: any) {
        const author = review && review.author ? review.author : {};
        return author.name || author.email || '-';
    }

    public reviewAuthorEmail(review: any) {
        const author = review && review.author ? review.author : {};
        return author.email || '-';
    }

    public reviewUserOptions() {
        return (this.reviewOptions && this.reviewOptions.users ? this.reviewOptions.users : [])
            .filter((user: any) => user && user.id);
    }

    public reviewGroupOptions() {
        return (this.reviewOptions && this.reviewOptions.groups ? this.reviewOptions.groups : [])
            .filter((group: any) => group && group.id);
    }

    public reviewProjectOptions() {
        return (this.reviewOptions && this.reviewOptions.projects ? this.reviewOptions.projects : [])
            .filter((project: any) => project && project.id);
    }

    public reviewTabTitle() {
        return '리뷰';
    }

    public reviewCodexWorkCountLabel(review: any) {
        const count = Math.max(0, Number(review && review.codex_work_count ? review.codex_work_count : 0) || 0);
        return count > 0 ? String(count) : '-';
    }

    public reviewEmptyMessage() {
        const hasFilter = Object.keys(this.reviewFilter || {}).some((key) => !!this.reviewFilter[key]);
        return hasFilter ? '검색 결과가 없습니다.' : '리뷰가 없습니다.';
    }

    public projectTypeLabel(project: any) {
        return project && project.project_type_label ? project.project_type_label : '웹서비스';
    }

    public codexStatusLabel(project: any) {
        return project && project.codex_enabled ? '활성' : '비활성';
    }

    public codexBadgeClass(project: any) {
        if (project && project.codex_enabled) return 'inline-flex shrink-0 whitespace-nowrap rounded-full bg-emerald-50 px-2 py-0.5 text-[11px] font-medium text-emerald-700';
        return 'inline-flex shrink-0 whitespace-nowrap rounded-full bg-slate-100 px-2 py-0.5 text-[11px] font-medium text-slate-500';
    }

    public codexAccountEmail(project: any) {
        const account = project && project.codex_status && project.codex_status.account ? project.codex_status.account : {};
        return account.email || account.name || '-';
    }

    public codexSubscriptionLabel(project: any) {
        if (!project || !project.codex_enabled) return '-';
        const status = project.codex_status || {};
        const account = status.account || {};
        const usage = status.usage || {};
        const weeklySummary = String(usage.summary || '')
            .split(/\s*\/\s*/)
            .filter((part: string) => part.toLowerCase().includes('weekly') && !part.toLowerCase().includes('spark'))
            .join(' / ');
        return account.plan || weeklySummary || '구독 정보 없음';
    }

    public codexCheckedAt(project: any) {
        const value = project && project.codex_status ? project.codex_status.checked_at : '';
        return this.service.formatter.kstDateTime(value, '');
    }

    public textValue(value: any) {
        if (value === null || value === undefined || value === '') return '';
        if (typeof value === 'object') {
            try {
                return JSON.stringify(value);
            } catch (e) {
                return '';
            }
        }
        return String(value);
    }

    public codexRouteLabel(value: any) {
        const route = String(value || '');
        if (route === 'local') return '로컬';
        if (route === 'proxy') return 'Proxy';
        if (route === 'double_proxy') return '이중 Proxy';
        if (route === 'direct') return '직접';
        return route || '-';
    }

    public codexAccountIdentity(row: any) {
        const account = row && row.account ? row.account : {};
        return account.email || row?.account_email || account.name || row?.account_name || row?.account_key || '-';
    }

    public codexAccountMeta(row: any) {
        const account = row && row.account ? row.account : {};
        const parts = [
            account.plan || row?.account_plan,
            this.codexRouteLabel(row?.route)
        ].filter((value: any) => !!value && value !== '-');
        return parts.length ? parts.join(' · ') : '계정 상세 없음';
    }

    public codexAccountPlan(row: any) {
        const account = row && row.account ? row.account : {};
        return this.textValue(row && row.account_plan) || this.textValue(account.plan);
    }

    public codexAccountStatusLabel(row: any) {
        const exitCode = Number(row && row.status_exit_code ? row.status_exit_code : 0);
        if (exitCode) return `실패 ${exitCode}`;
        if (row && row.is_stale) return '확인 지연';
        return row && row.status ? row.status : '정상';
    }

    public codexAccountStatusClass(row: any) {
        const exitCode = Number(row && row.status_exit_code ? row.status_exit_code : 0);
        const status = String(row && row.status ? row.status : '').toLowerCase();
        const base = 'inline-flex shrink-0 whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-medium ';
        if (exitCode || status.includes('fail') || status.includes('error') || status.includes('expired')) return base + 'bg-rose-50 text-rose-700';
        if (row && row.is_stale) return base + 'bg-amber-50 text-amber-700';
        if (!row || !row.last_checked) return base + 'bg-amber-50 text-amber-700';
        return base + 'bg-emerald-50 text-emerald-700';
    }

    public codexUsageLines(row: any) {
        const groups = Array.isArray(row && row.usage_groups) ? row.usage_groups : [];
        if (groups.length) {
            return groups.map((group: any) => {
                const label = this.textValue(group.label) || 'default';
                const remaining = this.textValue(group.remaining);
                return remaining ? `${label} ${remaining}` : label;
            }).filter((value: any) => !!value);
        }
        const summary = this.textValue(row && row.usage_summary);
        return summary ? [summary] : [];
    }

    public codexUsageResetText(row: any) {
        const groups = Array.isArray(row && row.usage_groups) ? row.usage_groups : [];
        return groups
            .map((group: any) => this.textValue(group.reset))
            .filter((value: any) => !!value)
            .join(' · ');
    }

    public codexDefaultUsage(row: any) {
        return row && row.default_usage ? row.default_usage : {};
    }

    private codexUsagePercentNumber(value: any) {
        const text = this.textValue(value).replace('%', '').replace(/,/g, '').trim();
        if (!text) return null;
        const numeric = Number(text);
        return Number.isFinite(numeric) ? numeric : null;
    }

    private codexUsageRemainingNumber(row: any, window: string) {
        const usage = this.codexDefaultUsage(row);
        return this.codexUsagePercentNumber(usage.remaining_weekly);
    }

    private codexAccountRows(rows: any[]) {
        return (Array.isArray(rows) ? rows : [])
            .slice()
            .sort((a: any, b: any) => {
                const weeklyA = this.codexUsageRemainingNumber(a, 'weekly');
                const weeklyB = this.codexUsageRemainingNumber(b, 'weekly');
                const sortA = weeklyA === null ? Number.POSITIVE_INFINITY : Number(weeklyA);
                const sortB = weeklyB === null ? Number.POSITIVE_INFINITY : Number(weeklyB);
                if (sortA !== sortB) return sortA - sortB;
                if (!!a?.is_stale !== !!b?.is_stale) return a?.is_stale ? 1 : -1;
                return this.codexAccountIdentity(a).localeCompare(this.codexAccountIdentity(b));
            });
    }

    public codexUsagePercent(row: any, window: string) {
        const usage = this.codexDefaultUsage(row);
        return this.textValue(usage.remaining_weekly) || '-';
    }

    public codexUsageReset(row: any, window: string) {
        const usage = this.codexDefaultUsage(row);
        return this.textValue(usage.reset_weekly);
    }

    public codexResetAvailableCount(row: any) {
        return Math.max(Number(row && row.reset_available_count || 0) || 0, 0);
    }

    public canResetCodexUsage(row: any) {
        return !!(
            row
            && row.source_project_id
            && row.account_email
            && row.reset_supported
            && this.codexResetAvailableCount(row) > 0
        );
    }

    private codexResetIdempotencyKey(row: any) {
        const cryptoApi: any = (window as any).crypto;
        if (cryptoApi && typeof cryptoApi.randomUUID === 'function') return cryptoApi.randomUUID();
        return `reviewops-${Date.now()}-${String(row && row.id || '').slice(0, 24)}`;
    }

    public async resetCodexUsage(row: any, event?: any) {
        if (event && event.stopPropagation) event.stopPropagation();
        if (!this.canResetCodexUsage(row) || this.codexResettingAccountId) return;
        const accountLabel = this.codexAccountIdentity(row);
        const availableCount = this.codexResetAvailableCount(row);
        const ok = await this.service.modal.confirm({
            title: '에이전트 주간 사용량 초기화',
            message: `${accountLabel} 계정의 주간 사용량을 초기화할까요? 초기화권 1개가 사용됩니다. (현재 ${availableCount}개)`,
            action: '초기화',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!ok) return;
        this.codexResettingAccountId = row.id;
        await this.service.render();
        try {
            const credits = Array.isArray(row.reset_credits) ? row.reset_credits : [];
            const credit = credits.find((item: any) => item && item.status === 'available');
            const { code, data } = await wiz.call('reset_codex_account_usage', Object.assign(this.params(), {
                active_tab: 'codex',
                codex_refresh_target: 'accounts',
                data: JSON.stringify({
                    source_project_id: row.source_project_id,
                    account_email: row.account_email,
                    credit_id: credit && credit.id || '',
                    idempotency_key: this.codexResetIdempotencyKey(row)
                })
            }));
            if (code !== 200) {
                await this.service.modal.error((data && data.message) || 'OpenAI 사용량을 초기화하지 못했습니다.');
                return;
            }
            this.applyCodexData(data || {}, false);
            if (data && data.result && data.result.ok) {
                await this.service.modal.success(data.result.message || '에이전트 주간 사용량을 초기화했습니다.');
            } else {
                await this.service.modal.error((data && data.result && data.result.message) || '초기화할 사용량이 없습니다.');
            }
        } catch (e) {
            await this.service.modal.error('OpenAI 사용량을 초기화하지 못했습니다.');
        } finally {
            this.codexResettingAccountId = '';
            await this.service.render();
        }
    }

    public codexProjectGroupAccountLabel(group: any) {
        const account = group && group.account ? group.account : {};
        return account.label || account.email || account.name || account.id || account.key || '-';
    }

    public codexProjectGroupMeta(group: any) {
        const account = group && group.account ? group.account : {};
        const parts = [
            account.plan,
            account.organization,
            this.codexRouteLabel(account.route)
        ].filter((value: any) => !!value && value !== '-');
        return parts.length ? parts.join(' · ') : '계정 상세 없음';
    }

    public isCodexProjectGroupCollapsed(group: any) {
        const key = String(group && group.key || '');
        return this.codexProjectCollapsed[key] !== false;
    }

    public async toggleCodexProjectGroup(group: any) {
        const key = String(group && group.key || '');
        if (!key) return;
        this.codexProjectCollapsed[key] = !this.isCodexProjectGroupCollapsed(group);
        await this.service.render();
    }

    public codexProjectGroupUsagePercent(group: any, window: string) {
        return this.codexUsagePercent(group, window);
    }

    public codexProjectAccountLabel(project: any) {
        const account = project && project.codex_account ? project.codex_account : {};
        return account.label || account.email || account.name || account.id || this.codexAccountEmail(project);
    }

    public codexProjectAccountMeta(project: any) {
        const account = project && project.codex_account ? project.codex_account : {};
        const parts = [
            account.plan || this.codexSubscriptionLabel(project),
            account.organization,
            this.codexRouteLabel(account.route || (project && project.codex_status ? project.codex_status.route : ''))
        ].filter((value: any) => !!value && value !== '-');
        return parts.length ? parts.join(' · ') : '-';
    }

    public projectSshLabel(project: any) {
        const host = project && project.ssh_host ? project.ssh_host : '';
        const user = project && project.ssh_user ? project.ssh_user : '';
        const port = project && project.ssh_port ? project.ssh_port : 22;
        if (!host && !user) return '-';
        return `${user || '-'}@${host || '-'}:${port}`;
    }

    public projectProxyLabel(project: any) {
        if (!project || !project.ssh_proxy_enabled) return '직접';
        const first = project.ssh_proxy_host ? `Proxy ${project.ssh_proxy_user || '-'}@${project.ssh_proxy_host}` : 'Proxy';
        if (!project.ssh_proxy2_enabled) return first;
        const second = project.ssh_proxy2_host ? `2차 ${project.ssh_proxy2_user || '-'}@${project.ssh_proxy2_host}` : '2차 Proxy';
        return `${first} -> ${second}`;
    }

    public projectCodexRootPath(project: any) {
        return this.textValue(project && project.codex_root_path) || this.textValue(project && project.codex_status ? project.codex_status.root_path : '') || '-';
    }

    public projectCodexCommandPath(project: any) {
        return this.textValue(project && project.codex_command_path) || '기본값: codex';
    }

    public codexProjectRecentErrorCount(project: any) {
        return Math.max(0, Number(project && project.codex_recent_error_count || 0) || 0);
    }

    public codexProjectRecentErrorLabel(project: any) {
        const hours = Number(project && project.codex_recent_error_window_hours || 12) || 12;
        return `최근 ${hours}시간 오류 ${this.dashboardCount(this.codexProjectRecentErrorCount(project))}건`;
    }

    public codexProjectErrorButtonClass(project: any) {
        const count = this.codexProjectRecentErrorCount(project);
        const base = 'inline-flex w-fit items-center gap-1 rounded-md px-1.5 py-0.5 text-[11px] font-semibold';
        return count > 0
            ? `${base} bg-rose-50 text-rose-700 hover:bg-rose-100`
            : `${base} bg-slate-50 text-slate-400 hover:bg-slate-100 hover:text-slate-600`;
    }

    public async openCodexProjectErrorLogs(project: any, event: any = null) {
        if (event && event.stopPropagation) event.stopPropagation();
        const projectId = String(project && project.id || '').trim();
        if (!projectId) return;
        this.codexProjectErrorLogModal = {
            open: true,
            loading: true,
            project,
            logs: [],
            selected: null,
            total: this.codexProjectRecentErrorCount(project),
            limit: 50,
            period_label: `최근 ${Number(project && project.codex_recent_error_window_hours || 12) || 12}시간`,
            error: ''
        };
        await this.service.render();
        try {
            const { code, data } = await wiz.call('load_codex_project_error_logs', {
                data: JSON.stringify({ project_id: projectId })
            });
            if (code === 200) {
                const logs = Array.isArray(data && data.logs) ? data.logs : [];
                this.codexProjectErrorLogModal = Object.assign({}, this.codexProjectErrorLogModal, {
                    loading: false,
                    project: (data && data.project) || project,
                    logs,
                    selected: logs.length ? logs[0] : null,
                    total: Number(data && data.total || logs.length) || 0,
                    limit: Number(data && data.limit || 50) || 50,
                    period_label: (data && data.period_label) || this.codexProjectErrorLogModal.period_label,
                    error: ''
                });
            } else {
                this.codexProjectErrorLogModal = Object.assign({}, this.codexProjectErrorLogModal, {
                    loading: false,
                    error: (data && data.message) || '오류 로그를 불러오지 못했습니다.'
                });
            }
        } catch (e) {
            this.codexProjectErrorLogModal = Object.assign({}, this.codexProjectErrorLogModal, {
                loading: false,
                error: '오류 로그를 불러오지 못했습니다.'
            });
        }
        await this.service.render();
    }

    public async closeCodexProjectErrorLogs() {
        this.codexProjectErrorLogModal = { open: false, loading: false, project: null, logs: [], selected: null, total: 0, limit: 50, period_label: '최근 12시간', error: '' };
        await this.service.render();
    }

    public codexProjectErrorModalProjectName() {
        const project = this.codexProjectErrorLogModal && this.codexProjectErrorLogModal.project ? this.codexProjectErrorLogModal.project : {};
        return project.name || project.id || '-';
    }

    public codexProjectErrorLogs() {
        const rows = this.codexProjectErrorLogModal && this.codexProjectErrorLogModal.logs ? this.codexProjectErrorLogModal.logs : [];
        return Array.isArray(rows) ? rows : [];
    }

    public selectCodexProjectErrorLog(log: any) {
        this.codexProjectErrorLogModal.selected = log || null;
        this.service.render();
    }

    public codexProjectErrorSelectedLog() {
        return this.codexProjectErrorLogModal && this.codexProjectErrorLogModal.selected
            ? this.codexProjectErrorLogModal.selected
            : (this.codexProjectErrorLogs()[0] || null);
    }

    public codexProjectErrorLogButtonClass(log: any) {
        const selected = this.codexProjectErrorSelectedLog();
        const active = selected && log && selected.id === log.id;
        const base = 'block w-full rounded-md border px-3 py-2 text-left';
        return active
            ? `${base} border-rose-200 bg-rose-50`
            : `${base} border-slate-200 bg-white hover:bg-slate-50`;
    }

    public codexProjectErrorLogContent() {
        const log = this.codexProjectErrorSelectedLog();
        return log && log.content ? String(log.content) : '내용 없음';
    }

    public codexProjectErrorLogRequestContent() {
        const log = this.codexProjectErrorSelectedLog();
        return log && log.request_content ? String(log.request_content) : '요청 내용을 찾지 못했습니다.';
    }

    public projectCodexLoginBusy(project: any = this.selectedCodexProjectLogin) {
        return !!(project && project.id && this.projectCodexLoginBusyId === project.id);
    }

    public canOpenProjectCodexLogin(project: any) {
        if (!project || !project.id || this.projectCodexLoginBusyId) return false;
        if (project.is_html_project) return false;
        return true;
    }

    public projectCodexLoginOpenDisabledReason(project: any) {
        if (!project || !project.id) return '프로젝트 정보가 없습니다.';
        if (this.projectCodexLoginBusyId) return '에이전트 인증 처리 중입니다.';
        if (project.is_html_project) return 'HTML 프로젝트의 로컬 에이전트 인증은 프로젝트 설정에서 처리해주세요.';
        return '에이전트 프로젝트 연동 정보를 엽니다.';
    }

    public canStartProjectCodexLogin(project: any) {
        if (!project || !project.id || this.projectCodexLoginBusyId) return false;
        if (project.is_html_project) return false;
        return !!(
            String(project.ssh_host || '').trim()
            && String(project.ssh_user || '').trim()
            && String(project.codex_root_path || '').trim()
        );
    }

    public projectCodexLoginDisabledReason(project: any) {
        if (!project || !project.id) return '프로젝트 정보가 없습니다.';
        if (this.projectCodexLoginBusyId) return '에이전트 인증 처리 중입니다.';
        if (project.is_html_project) return 'HTML 프로젝트의 로컬 에이전트 인증은 프로젝트 설정에서 처리해주세요.';
        if (!String(project.ssh_host || '').trim()) return 'SSH Host가 필요합니다.';
        if (!String(project.ssh_user || '').trim()) return 'SSH ID가 필요합니다.';
        if (!String(project.codex_root_path || '').trim()) return '에이전트 프로젝트 루트 경로가 필요합니다.';
        return 'OpenAI 디바이스 인증을 시작합니다.';
    }

    private codexAccountUsagePayload(row: any) {
        const account = row && row.account ? row.account : {};
        return {
            account_key: row?.account_key || '',
            account_id: row?.account_id || account.id || '',
            account_email: row?.account_email || account.email || '',
            account_name: row?.account_name || account.name || '',
            account_plan: row?.account_plan || account.plan || '',
            organization: row?.organization || account.organization || '',
            default_usage: this.codexDefaultUsage(row),
            account: {
                id: account.id || '',
                email: account.email || '',
                name: account.name || '',
                plan: account.plan || '',
                organization: account.organization || ''
            }
        };
    }

    public async openCodexAccountUsage(account: any) {
        if (!account) return;
        this.selectedCodexAccount = account;
        this.codexAccountUsageOpen = true;
        await this.loadCodexAccountUsage();
    }

    public async loadCodexAccountUsage() {
        if (!this.selectedCodexAccount) return;
        this.codexAccountUsageLoading = true;
        await this.service.render();

        const payload = this.codexAccountUsagePayload(this.selectedCodexAccount);
        const { code, data } = await wiz.call('load_codex_account_usage_dashboard', { data: JSON.stringify(payload) });
        if (code === 200) {
            this.codexAccountUsageDashboard = data.dashboard || this.codexAccountUsageDashboard;
        } else {
            this.codexAccountUsageOpen = false;
            this.selectedCodexAccount = null;
            await this.service.modal.error(data.message || 'OpenAI 계정 사용량을 불러오지 못했습니다.');
        }

        this.codexAccountUsageLoading = false;
        await this.service.render();
        this.scheduleChartRender();
    }

    public async closeCodexAccountUsage() {
        this.codexAccountUsageOpen = false;
        this.codexAccountUsageLoading = false;
        this.selectedCodexAccount = null;
        await this.service.render();
        this.destroyCharts('codexAccountUsage');
    }

    public codexAccountUsageHours() {
        return this.codexAccountUsageDashboard
            && this.codexAccountUsageDashboard.chart
            && Array.isArray(this.codexAccountUsageDashboard.chart.hours)
            ? this.codexAccountUsageDashboard.chart.hours
            : this.codexAccountUsageDashboard
                && this.codexAccountUsageDashboard.chart
                && Array.isArray(this.codexAccountUsageDashboard.chart.days)
                ? this.codexAccountUsageDashboard.chart.days
                : [];
    }

    public codexAccountUsageDays() {
        return this.codexAccountUsageHours();
    }

    public codexAccountUsageSnapshotCountLabel() {
        const totals = this.codexAccountUsageDashboard && this.codexAccountUsageDashboard.totals
            ? this.codexAccountUsageDashboard.totals
            : {};
        return `상태 확인 ${this.dashboardCount(totals.status_hours)}시간 · ${this.dashboardCount(totals.status_snapshots)}건`;
    }

    public codexAccountUsageTickLabel(item: any, index: number, total: number) {
        if (!item) return '';
        if (index === 0 || index === total - 1 || Number(item.hour) === 0) {
            return item.tick_label || String(item.date || '').slice(5);
        }
        return '';
    }

    public codexAccountUsagePercent(window: string = 'weekly') {
        const totals = this.codexAccountUsageDashboard && this.codexAccountUsageDashboard.totals
            ? this.codexAccountUsageDashboard.totals
            : {};
        return this.textValue(totals.current_remaining_weekly) || '-';
    }

    public codexAccountUsageChartEmpty() {
        return this.codexAccountUsageDays().every((day: any) => {
            const hasWeekly = day && day.remaining_weekly !== null && day.remaining_weekly !== undefined;
            return !hasWeekly;
        });
    }

    public codexRequestStatusButtonClass(value: string) {
        const active = this.codexRequestFilter.status === value;
        const base = 'inline-flex h-9 flex-1 items-center justify-center rounded-md px-3 text-[12px] font-semibold transition';
        return active ? `${base} bg-slate-900 text-white shadow-sm` : `${base} text-slate-500 hover:bg-white hover:text-slate-900`;
    }

    public codexRequestStatusLabel(request: any) {
        const status = String(request && request.status || '');
        const labels: any = {
            requested: '요청됨',
            in_progress: '처리중',
            completed: '완료',
            failed: '실패',
            cancelled: '취소'
        };
        return (request && request.status_label) || labels[status] || '-';
    }

    public codexRequestStatusClass(request: any) {
        const base = 'inline-flex shrink-0 whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-medium ';
        const status = String(request && request.status || '');
        if (status === 'completed') return base + 'bg-emerald-50 text-emerald-700';
        if (status === 'failed') return base + 'bg-rose-50 text-rose-700';
        if (status === 'cancelled') return base + 'bg-slate-100 text-slate-500';
        if (status === 'in_progress') return base + 'bg-indigo-50 text-indigo-700';
        return base + 'bg-amber-50 text-amber-700';
    }

    public codexRequestProject(request: any) {
        return request && request.project ? request.project : {};
    }

    public codexRequestProjectName(request: any) {
        const project = this.codexRequestProject(request);
        return project.name || request?.project_id || '-';
    }

    public codexRequestGroupName(request: any) {
        const project = this.codexRequestProject(request);
        return project.group_name || '-';
    }

    public codexRequestSshLabel(request: any) {
        const project = this.codexRequestProject(request);
        const host = project.ssh_host || '-';
        const user = project.ssh_user || '-';
        const port = project.ssh_port || 22;
        return `${user}@${host}:${port}`;
    }

    public codexRequestProxyLabel(request: any) {
        const project = this.codexRequestProject(request);
        if (!project.ssh_proxy_enabled) return '직접';
        const first = project.ssh_proxy_host ? `Proxy ${project.ssh_proxy_user || '-'}@${project.ssh_proxy_host}` : 'Proxy';
        if (!project.ssh_proxy2_enabled) return first;
        const second = project.ssh_proxy2_host ? `2차 ${project.ssh_proxy2_user || '-'}@${project.ssh_proxy2_host}` : '2차 Proxy';
        return `${first} -> ${second}`;
    }

    public codexRequestRequester(request: any) {
        return request?.requester_label || request?.requester_email || request?.requester_user_id || '-';
    }

    public codexRequestAdmin(request: any) {
        return request?.admin_label || request?.admin_email || '-';
    }

    public selectedCodexLoginRequestStatus() {
        return this.codexRequestStatusLabel(this.selectedCodexLoginRequest);
    }

    public selectedCodexLoginRequestAuth() {
        return this.codexLoginRequestAuth || (this.selectedCodexLoginRequest && this.selectedCodexLoginRequest.device_auth) || {};
    }

    private codexDeviceCodeCopyKey(deviceCode: any, scope: string = 'request') {
        return `${scope}:${String(deviceCode || '').trim()}`;
    }

    public codexDeviceCodeCopied(deviceCode: any, scope: string = 'request') {
        const code = String(deviceCode || '').trim();
        return !!code && this.codexCopiedDeviceCodeKey === this.codexDeviceCodeCopyKey(code, scope);
    }

    private async writeCodexDeviceCodeToClipboard(text: string) {
        if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText) {
            try {
                await navigator.clipboard.writeText(text);
                return;
            } catch (e) { }
        }
        if (typeof document === 'undefined' || !document.body) throw new Error('clipboard unavailable');
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', 'readonly');
        textarea.style.position = 'fixed';
        textarea.style.left = '-9999px';
        textarea.style.top = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        const copied = document.execCommand('copy');
        textarea.remove();
        if (!copied) throw new Error('clipboard copy failed');
    }

    public async copyCodexDeviceCode(deviceCode: any, scope: string = 'request') {
        const code = String(deviceCode || '').trim();
        if (!code) return;
        try {
            await this.writeCodexDeviceCodeToClipboard(code);
            this.codexCopiedDeviceCodeKey = this.codexDeviceCodeCopyKey(code, scope);
        } catch (e) {
            this.codexCopiedDeviceCodeKey = '';
        }
        await this.service.render();
    }

    public codexLoginRequestCancelReasonReady() {
        return !!String(this.codexLoginRequestCancelReason || '').trim();
    }

    public codexLoginRequestBusy(request: any = this.selectedCodexLoginRequest) {
        return !!(request && request.id && this.codexLoginRequestBusyId === request.id);
    }

    private codexRequestTerminalProjectId(request: any = this.codexRequestTerminalRequest || this.selectedCodexLoginRequest) {
        const project = this.codexRequestProject(request);
        return String((project && project.id) || (request && request.project_id) || '').trim();
    }

    private codexRequestTerminalActiveProject() {
        if (this.codexRequestTerminalMode === 'project') {
            return this.codexRequestTerminalProject || this.selectedCodexProjectLogin || {};
        }
        return this.codexRequestProject(this.codexRequestTerminalRequest || this.selectedCodexLoginRequest);
    }

    private codexRequestTerminalActiveProjectId() {
        const project = this.codexRequestTerminalActiveProject();
        if (this.codexRequestTerminalMode === 'project') return String(project && project.id || '').trim();
        return this.codexRequestTerminalProjectId(this.codexRequestTerminalRequest || this.selectedCodexLoginRequest);
    }

    private codexRequestTerminalLoginRequestId() {
        const request = this.codexRequestTerminalRequest || this.selectedCodexLoginRequest || {};
        return this.codexRequestTerminalMode === 'request' ? String(request.id || '').trim() : '';
    }

    public codexRequestCanOpenTerminal(request: any = this.selectedCodexLoginRequest) {
        const project = this.codexRequestProject(request);
        return !!(
            request && request.id
            && this.codexRequestTerminalProjectId(request)
            && String(project && project.ssh_host || '').trim()
            && String(project && project.ssh_user || '').trim()
        );
    }

    public codexRequestTerminalDisabledReason(request: any = this.selectedCodexLoginRequest) {
        const project = this.codexRequestProject(request);
        if (!request || !request.id) return '에이전트 요청 정보가 없습니다.';
        if (!this.codexRequestTerminalProjectId(request)) return '프로젝트 정보가 없습니다.';
        if (!String(project && project.ssh_host || '').trim()) return 'SSH Host가 필요합니다.';
        if (!String(project && project.ssh_user || '').trim()) return 'SSH ID가 필요합니다.';
        return '요청 서버 SSH 터미널을 엽니다.';
    }

    public projectCodexCanOpenTerminal(project: any = this.selectedCodexProjectLogin) {
        return !!(
            project && project.id
            && String(project.ssh_host || '').trim()
            && String(project.ssh_user || '').trim()
        );
    }

    public projectCodexTerminalDisabledReason(project: any = this.selectedCodexProjectLogin) {
        if (!project || !project.id) return '프로젝트 정보가 없습니다.';
        if (!String(project.ssh_host || '').trim()) return 'SSH Host가 필요합니다.';
        if (!String(project.ssh_user || '').trim()) return 'SSH ID가 필요합니다.';
        return '프로젝트 서버 SSH 터미널을 엽니다.';
    }

    public codexRequestTerminalTitle() {
        return this.codexRequestTerminalMode === 'project' ? '에이전트 프로젝트 SSH 터미널' : '에이전트 요청 SSH 터미널';
    }

    public codexRequestTerminalSubtitle() {
        const project = this.codexRequestTerminalActiveProject();
        const name = project && project.name ? project.name : this.codexRequestProjectName(this.codexRequestTerminalRequest);
        const ssh = this.projectSshLabel(project);
        const status = this.codexRequestTerminalStatusMessage || 'SSH 서버 login shell';
        return `${name || '-'} · ${ssh || '-'} · ${status}`;
    }

    public async openCodexRequestTerminal(request: any = this.selectedCodexLoginRequest) {
        if (!this.codexRequestCanOpenTerminal(request)) {
            await this.service.modal.error(this.codexRequestTerminalDisabledReason(request));
            return;
        }
        this.stopCodexRequestTerminal(false);
        this.disposeCodexRequestTerminal();
        this.codexRequestTerminalMode = 'request';
        this.codexRequestTerminalRequest = request;
        this.codexRequestTerminalProject = null;
        this.codexRequestTerminalOpen = true;
        this.codexRequestTerminalError = '';
        this.codexRequestTerminalStatusMessage = '터미널 연결 준비';
        await this.service.render();
        await this.service.sleep(0);
        await this.startCodexRequestTerminal();
    }

    public async openCodexProjectTerminal(project: any = this.selectedCodexProjectLogin) {
        if (!this.projectCodexCanOpenTerminal(project)) {
            await this.service.modal.error(this.projectCodexTerminalDisabledReason(project));
            return;
        }
        this.stopCodexRequestTerminal(false);
        this.disposeCodexRequestTerminal();
        this.codexRequestTerminalMode = 'project';
        this.codexRequestTerminalRequest = null;
        this.codexRequestTerminalProject = project;
        this.codexRequestTerminalOpen = true;
        this.codexRequestTerminalError = '';
        this.codexRequestTerminalStatusMessage = '터미널 연결 준비';
        await this.service.render();
        await this.service.sleep(0);
        await this.startCodexRequestTerminal();
    }

    public async closeCodexRequestTerminal() {
        this.stopCodexRequestTerminal(false);
        this.disposeCodexRequestTerminal();
        this.disconnectCodexRequestTerminalSocket();
        this.codexRequestTerminalOpen = false;
        this.codexRequestTerminalMode = 'request';
        this.codexRequestTerminalRequest = null;
        this.codexRequestTerminalProject = null;
        this.codexRequestTerminalError = '';
        this.codexRequestTerminalStatusMessage = '';
        await this.service.render();
    }

    public codexRequestTerminalElement() {
        return document.getElementById('reviewops-codex-request-terminal');
    }

    public ensureCodexRequestTerminal() {
        const element = this.codexRequestTerminalElement();
        if (!element) return false;
        if (this.codexRequestTerminal) {
            if (this.codexRequestTerminalHostElement === element && element.querySelector('.xterm')) {
                this.scheduleCodexRequestTerminalFit();
                return true;
            }
            this.disposeCodexRequestTerminal();
        }
        this.codexRequestTerminal = new Terminal({
            cursorBlink: true,
            convertEol: true,
            fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
            fontSize: 12,
            lineHeight: 1.45,
            scrollback: 5000,
            theme: {
                background: '#020617',
                foreground: '#e2e8f0',
                cursor: '#f8fafc',
                selectionBackground: '#334155'
            }
        });
        this.codexRequestTerminalFitAddon = new FitAddon();
        this.codexRequestTerminalWebLinksAddon = new WebLinksAddon();
        this.codexRequestTerminal.loadAddon(this.codexRequestTerminalFitAddon);
        this.codexRequestTerminal.loadAddon(this.codexRequestTerminalWebLinksAddon);
        this.codexRequestTerminal.open(element);
        this.codexRequestTerminalHostElement = element;
        this.codexRequestTerminalInputDisposable = this.codexRequestTerminal.onData((data: string) => {
            this.emitCodexRequestTerminalSocket('terminal_input', { data });
        });
        this.scheduleCodexRequestTerminalFit();
        return true;
    }

    public scheduleCodexRequestTerminalFit() {
        if (this.codexRequestTerminalResizeTimer) window.clearTimeout(this.codexRequestTerminalResizeTimer);
        this.codexRequestTerminalResizeTimer = window.setTimeout(() => {
            this.codexRequestTerminalResizeTimer = null;
            this.fitCodexRequestTerminal(true);
        }, 80);
    }

    public fitCodexRequestTerminal(emitResize: boolean = false) {
        if (!this.codexRequestTerminal || !this.codexRequestTerminalFitAddon) return;
        try {
            this.codexRequestTerminalFitAddon.fit();
            if (emitResize && this.codexRequestTerminalReady) {
                this.emitCodexRequestTerminalSocket('terminal_resize', {
                    cols: this.codexRequestTerminal.cols || 100,
                    rows: this.codexRequestTerminal.rows || 32
                });
            }
        } catch (e) { }
    }

    public codexRequestTerminalSocketNamespace() {
        const projectName = typeof wiz.project === 'function' ? wiz.project() : 'main';
        return `/wiz/app/${projectName}/page.projects.item`;
    }

    public codexRequestTerminalSocketEnvelope(payload: any = {}) {
        const projectId = this.codexRequestTerminalActiveProjectId();
        const requestId = this.codexRequestTerminalLoginRequestId();
        const basePayload = {
            project_id: projectId,
            admin: '1',
            admin_terminal: '1',
            codex_login_request_id: requestId
        };
        return {
            project_id: projectId,
            admin: '1',
            admin_terminal: '1',
            codex_login_request_id: requestId,
            payload: Object.assign(basePayload, payload || {})
        };
    }

    public emitCodexRequestTerminalSocket(event: string, payload: any = {}) {
        if (!this.codexRequestTerminalSocket || !this.codexRequestTerminalSocket.connected) return;
        this.codexRequestTerminalSocket.emit(event, this.codexRequestTerminalSocketEnvelope(payload));
    }

    public async connectCodexRequestTerminalSocket() {
        if (this.codexRequestTerminalSocket && this.codexRequestTerminalSocket.connected) return true;
        if (this.codexRequestTerminalSocketConnecting) {
            for (let i = 0; i < 15; i++) {
                await this.service.sleep(120);
                if (this.codexRequestTerminalSocket && this.codexRequestTerminalSocket.connected) return true;
                if (!this.codexRequestTerminalSocketConnecting) break;
            }
            return !!(this.codexRequestTerminalSocket && this.codexRequestTerminalSocket.connected);
        }

        this.codexRequestTerminalSocketConnecting = true;
        if (!this.codexRequestTerminalSocket) {
            this.codexRequestTerminalSocket = io.connect(this.codexRequestTerminalSocketNamespace(), {
                transports: ['websocket', 'polling'],
                reconnection: true,
                reconnectionAttempts: 5,
                reconnectionDelay: 500
            });
            this.codexRequestTerminalSocket.on('connect', () => {
                this.codexRequestTerminalSocketConnected = true;
                this.codexRequestTerminalSocketConnecting = false;
            });
            this.codexRequestTerminalSocket.on('disconnect', () => {
                this.codexRequestTerminalSocketConnected = false;
            });
            this.codexRequestTerminalSocket.on('terminal_ready', (data: any) => {
                this.handleCodexRequestTerminalReady(data);
            });
            this.codexRequestTerminalSocket.on('terminal_data', (data: any) => {
                this.handleCodexRequestTerminalData(data);
            });
            this.codexRequestTerminalSocket.on('terminal_error', (data: any) => {
                this.handleCodexRequestTerminalError(data);
            });
            this.codexRequestTerminalSocket.on('terminal_closed', (data: any) => {
                this.handleCodexRequestTerminalClosed(data);
            });
        } else {
            try {
                this.codexRequestTerminalSocket.connect();
            } catch (e) { }
        }

        return await new Promise<boolean>((resolve) => {
            if (this.codexRequestTerminalSocket.connected) {
                this.codexRequestTerminalSocketConnected = true;
                this.codexRequestTerminalSocketConnecting = false;
                resolve(true);
                return;
            }
            const timer = window.setTimeout(() => {
                this.codexRequestTerminalSocketConnecting = false;
                resolve(false);
            }, 1800);
            this.codexRequestTerminalSocket.once('connect', () => {
                window.clearTimeout(timer);
                this.codexRequestTerminalSocketConnected = true;
                this.codexRequestTerminalSocketConnecting = false;
                resolve(true);
            });
            this.codexRequestTerminalSocket.once('connect_error', () => {
                window.clearTimeout(timer);
                this.codexRequestTerminalSocketConnecting = false;
                resolve(false);
            });
        });
    }

    public disconnectCodexRequestTerminalSocket() {
        if (!this.codexRequestTerminalSocket) return;
        try {
            this.codexRequestTerminalSocket.emit('leave_terminal', this.codexRequestTerminalSocketEnvelope({}));
            this.codexRequestTerminalSocket.disconnect();
        } catch (e) { }
        this.codexRequestTerminalSocket = null;
        this.codexRequestTerminalSocketConnected = false;
        this.codexRequestTerminalSocketConnecting = false;
    }

    public clearCodexRequestTerminalConnectTimer() {
        if (!this.codexRequestTerminalConnectTimer) return;
        window.clearTimeout(this.codexRequestTerminalConnectTimer);
        this.codexRequestTerminalConnectTimer = null;
    }

    public scheduleCodexRequestTerminalConnectTimeout() {
        this.clearCodexRequestTerminalConnectTimer();
        this.codexRequestTerminalConnectTimer = window.setTimeout(() => {
            this.codexRequestTerminalConnectTimer = null;
            if (!this.codexRequestTerminalStarting || this.codexRequestTerminalReady) return;
            this.codexRequestTerminalStarting = false;
            this.codexRequestTerminalReady = false;
            this.codexRequestTerminalError = '터미널 소켓 응답이 없습니다. 잠시 후 다시 연결해주세요.';
            this.codexRequestTerminalStatusMessage = '터미널 연결 실패';
            if (this.codexRequestTerminal) this.codexRequestTerminal.writeln(`\r\n[ReviewOps] ${this.codexRequestTerminalError}`);
            if (this.codexRequestTerminalSocket && this.codexRequestTerminalSocket.connected) {
                try {
                    this.codexRequestTerminalSocket.emit('leave_terminal', this.codexRequestTerminalSocketEnvelope({}));
                } catch (e) { }
            }
            this.service.render();
        }, 30000);
    }

    public async startCodexRequestTerminal() {
        if (!this.codexRequestTerminalOpen || this.codexRequestTerminalStarting) return;
        const canOpenTerminal = this.codexRequestTerminalMode === 'project'
            ? this.projectCodexCanOpenTerminal(this.codexRequestTerminalProject)
            : this.codexRequestCanOpenTerminal(this.codexRequestTerminalRequest);
        if (!canOpenTerminal) {
            this.codexRequestTerminalError = this.codexRequestTerminalMode === 'project'
                ? this.projectCodexTerminalDisabledReason(this.codexRequestTerminalProject)
                : this.codexRequestTerminalDisabledReason(this.codexRequestTerminalRequest);
            await this.service.render();
            return;
        }
        if (this.codexRequestTerminalReady) {
            this.scheduleCodexRequestTerminalFit();
            return;
        }
        this.codexRequestTerminalStarting = true;
        this.codexRequestTerminalError = '';
        this.codexRequestTerminalStatusMessage = '터미널 연결 중';
        await this.service.render();
        await this.service.sleep(0);
        if (!this.ensureCodexRequestTerminal()) {
            this.codexRequestTerminalStarting = false;
            this.codexRequestTerminalError = '터미널 영역을 찾을 수 없습니다.';
            await this.service.render();
            return;
        }
        this.codexRequestTerminal.clear();
        this.codexRequestTerminal.writeln('ReviewOps terminal connecting...');
        const connected = await this.connectCodexRequestTerminalSocket();
        if (!connected || !this.codexRequestTerminalSocket) {
            this.codexRequestTerminalStarting = false;
            this.codexRequestTerminalReady = false;
            this.codexRequestTerminalError = '터미널 소켓에 연결하지 못했습니다.';
            this.codexRequestTerminal.writeln(this.codexRequestTerminalError);
            await this.service.render();
            return;
        }
        this.fitCodexRequestTerminal(false);
        this.codexRequestTerminalSocket.emit('join_terminal', this.codexRequestTerminalSocketEnvelope({
            cols: this.codexRequestTerminal.cols || 100,
            rows: this.codexRequestTerminal.rows || 32
        }));
        this.scheduleCodexRequestTerminalConnectTimeout();
        await this.service.render();
    }

    public stopCodexRequestTerminal(writeMessage: boolean = true) {
        this.clearCodexRequestTerminalConnectTimer();
        if (this.codexRequestTerminalSocket && this.codexRequestTerminalSocket.connected) {
            try {
                this.codexRequestTerminalSocket.emit('leave_terminal', this.codexRequestTerminalSocketEnvelope({}));
            } catch (e) { }
        }
        this.codexRequestTerminalStarting = false;
        this.codexRequestTerminalReady = false;
        this.codexRequestTerminalStatusMessage = '';
        if (writeMessage && this.codexRequestTerminal) this.codexRequestTerminal.writeln('\r\n[ReviewOps] terminal closed');
    }

    public disposeCodexRequestTerminal() {
        try {
            if (this.codexRequestTerminalInputDisposable) this.codexRequestTerminalInputDisposable.dispose();
        } catch (e) { }
        try {
            if (this.codexRequestTerminal) this.codexRequestTerminal.dispose();
        } catch (e) { }
        this.codexRequestTerminalInputDisposable = null;
        this.codexRequestTerminalFitAddon = null;
        this.codexRequestTerminalWebLinksAddon = null;
        this.codexRequestTerminal = null;
        this.codexRequestTerminalHostElement = null;
    }

    public handleCodexRequestTerminalReady(data: any) {
        this.clearCodexRequestTerminalConnectTimer();
        this.codexRequestTerminalStarting = false;
        this.codexRequestTerminalReady = true;
        this.codexRequestTerminalError = '';
        this.codexRequestTerminalStatusMessage = data && data.message ? data.message : '터미널에 연결되었습니다.';
        if (this.codexRequestTerminal) this.codexRequestTerminal.writeln('[ReviewOps] connected');
        this.scheduleCodexRequestTerminalFit();
        this.service.render();
    }

    public handleCodexRequestTerminalData(data: any) {
        if (!this.codexRequestTerminalOpen) return;
        if (!this.ensureCodexRequestTerminal()) return;
        this.codexRequestTerminal.write(data && data.data ? data.data : '');
    }

    public handleCodexRequestTerminalError(data: any) {
        this.clearCodexRequestTerminalConnectTimer();
        this.codexRequestTerminalStarting = false;
        this.codexRequestTerminalReady = false;
        this.codexRequestTerminalError = data && data.message ? data.message : '터미널 오류가 발생했습니다.';
        if (this.codexRequestTerminal) this.codexRequestTerminal.writeln(`\r\n[ReviewOps] ${this.codexRequestTerminalError}`);
        this.service.render();
    }

    public handleCodexRequestTerminalClosed(data: any) {
        this.clearCodexRequestTerminalConnectTimer();
        this.codexRequestTerminalStarting = false;
        this.codexRequestTerminalReady = false;
        this.codexRequestTerminalStatusMessage = data && data.message ? data.message : '터미널 연결이 종료되었습니다.';
        if (this.codexRequestTerminal) this.codexRequestTerminal.writeln(`\r\n[ReviewOps] ${this.codexRequestTerminalStatusMessage}`);
        this.service.render();
    }

    public syncSelectedCodexLoginRequest(updated: any) {
        if (!updated || !updated.id) return;
        this.selectedCodexLoginRequest = updated;
        if (this.codexRequestTerminalRequest && this.codexRequestTerminalRequest.id === updated.id) {
            this.codexRequestTerminalRequest = updated;
        }
        const index = this.codexRequests.findIndex((item: any) => item && item.id === updated.id);
        if (index >= 0) this.codexRequests[index] = updated;
    }

    public async openCodexLoginRequest(request: any) {
        this.selectedCodexLoginRequest = request || null;
        this.codexLoginRequestAuth = request && request.device_auth ? request.device_auth : null;
        this.codexCopiedDeviceCodeKey = '';
        await this.service.render();
    }

    public async closeCodexLoginRequest() {
        if (this.codexRequestTerminalOpen && this.codexRequestTerminalMode === 'request') {
            this.stopCodexRequestTerminal(false);
            this.disposeCodexRequestTerminal();
            this.disconnectCodexRequestTerminalSocket();
            this.codexRequestTerminalOpen = false;
            this.codexRequestTerminalMode = 'request';
            this.codexRequestTerminalRequest = null;
            this.codexRequestTerminalProject = null;
        }
        this.selectedCodexLoginRequest = null;
        this.codexLoginRequestAuth = null;
        this.codexCopiedDeviceCodeKey = '';
        this.codexLoginRequestBusyId = '';
        this.codexLoginRequestCancelTarget = null;
        this.codexLoginRequestCancelReason = '';
        await this.service.render();
    }

    public openCodexLoginRequestCancel(request: any = this.selectedCodexLoginRequest) {
        if (!request || !request.id || this.codexLoginRequestBusyId) return;
        if (['cancelled', 'completed'].includes(String(request.status || ''))) return;
        this.codexLoginRequestCancelTarget = request;
        this.codexLoginRequestCancelReason = '';
        this.service.render();
    }

    public closeCodexLoginRequestCancel() {
        if (this.codexLoginRequestBusy(this.codexLoginRequestCancelTarget)) return;
        this.codexLoginRequestCancelTarget = null;
        this.codexLoginRequestCancelReason = '';
        this.service.render();
    }

    public selectedCodexProjectLoginAuth() {
        return this.projectCodexLoginAuth || this.projectCodexLoginResult || {};
    }

    private findCodexProject(projectId: string) {
        for (const group of this.codexProjectGroups || []) {
            const projects = Array.isArray(group && group.projects) ? group.projects : [];
            const found = projects.find((project: any) => project && project.id === projectId);
            if (found) return found;
        }
        return null;
    }

    private syncSelectedCodexProject(projectId: string) {
        const found = this.findCodexProject(projectId);
        if (found) {
            this.selectedCodexProjectLogin = found;
            if (this.codexRequestTerminalProject && this.codexRequestTerminalProject.id === projectId) {
                this.codexRequestTerminalProject = found;
            }
        }
    }

    public async openProjectCodexLogin(project: any) {
        if (!project || !project.id || !this.canOpenProjectCodexLogin(project)) return;
        this.selectedCodexProjectLogin = project;
        this.projectCodexLoginAuth = null;
        this.projectCodexLoginResult = null;
        this.codexCopiedDeviceCodeKey = '';
        await this.service.render();
    }

    public async closeProjectCodexLogin() {
        if (this.codexRequestTerminalOpen && this.codexRequestTerminalMode === 'project') {
            this.stopCodexRequestTerminal(false);
            this.disposeCodexRequestTerminal();
            this.disconnectCodexRequestTerminalSocket();
            this.codexRequestTerminalOpen = false;
            this.codexRequestTerminalMode = 'request';
            this.codexRequestTerminalProject = null;
        }
        this.selectedCodexProjectLogin = null;
        this.projectCodexLoginAuth = null;
        this.projectCodexLoginResult = null;
        this.codexCopiedDeviceCodeKey = '';
        this.projectCodexLoginBusyId = '';
        await this.service.render();
    }

    public async startProjectCodexLogin(project: any = this.selectedCodexProjectLogin) {
        if (!project || !project.id || this.projectCodexLoginBusyId) return;
        this.projectCodexLoginBusyId = project.id;
        this.codexCopiedDeviceCodeKey = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('start_project_codex_login', Object.assign(this.params(), {
                active_tab: 'codex',
                codex_refresh_target: 'projects',
                data: JSON.stringify({ id: project.id })
            }));
            if (code === 200) {
                this.applyCodexData(data || {});
                this.syncSelectedCodexProject(project.id);
                this.projectCodexLoginResult = data && data.codex_project_login_result ? data.codex_project_login_result : {};
                this.projectCodexLoginAuth = data && data.codex_device_auth ? data.codex_device_auth : this.projectCodexLoginResult;
                if (this.projectCodexLoginResult && this.projectCodexLoginResult.ok === false) {
                    await this.service.modal.error(this.projectCodexLoginResult.message || '에이전트 인증 시작에 실패했습니다.');
                }
            } else {
                this.projectCodexLoginResult = { ok: false, message: (data && data.message) || '에이전트 인증 시작에 실패했습니다.' };
                await this.service.modal.error(this.projectCodexLoginResult.message);
            }
        } catch (e) {
            this.projectCodexLoginResult = { ok: false, message: '에이전트 인증 시작에 실패했습니다.' };
            await this.service.modal.error(this.projectCodexLoginResult.message);
        }
        this.projectCodexLoginBusyId = '';
        await this.service.render();
    }

    public async checkProjectCodexLogin(project: any = this.selectedCodexProjectLogin) {
        if (!project || !project.id || this.projectCodexLoginBusyId) return;
        this.projectCodexLoginBusyId = project.id;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('check_project_codex_login', Object.assign(this.params(), {
                active_tab: 'codex',
                codex_refresh_target: 'projects',
                data: JSON.stringify({ id: project.id })
            }));
            if (code === 200) {
                this.applyCodexData(data || {});
                this.syncSelectedCodexProject(project.id);
                const result = data && data.codex_project_login_result ? data.codex_project_login_result : {};
                this.projectCodexLoginResult = result;
                if (result.ok) {
                    this.projectCodexLoginAuth = null;
                    await this.closeProjectCodexLogin();
                    await this.service.modal.success(result.message || '에이전트 인증을 확인했습니다.');
                } else {
                    await this.service.modal.error(result.message || '에이전트 인증 확인에 실패했습니다.');
                }
            } else {
                await this.service.modal.error((data && data.message) || '에이전트 인증 확인에 실패했습니다.');
            }
        } catch (e) {
            await this.service.modal.error('에이전트 인증 확인에 실패했습니다.');
        }
        this.projectCodexLoginBusyId = '';
        await this.service.render();
    }

    public async startCodexLoginRequest(request: any = this.selectedCodexLoginRequest) {
        if (!request || !request.id || this.codexLoginRequestBusyId) return;
        this.codexLoginRequestBusyId = request.id;
        this.codexCopiedDeviceCodeKey = '';
        await this.service.render();
        const { code, data } = await wiz.call('start_codex_login_request', Object.assign(this.params(), {
            active_tab: 'codex',
            codex_refresh_target: 'requests',
            data: JSON.stringify({ id: request.id })
        }));
        this.codexLoginRequestBusyId = '';
        if (code === 200) {
            this.applyCodexData(data || {});
            if (data && data.codex_login_request) this.syncSelectedCodexLoginRequest(data.codex_login_request);
            this.codexLoginRequestAuth = (data && data.codex_device_auth) || (this.selectedCodexLoginRequest && this.selectedCodexLoginRequest.device_auth) || null;
            const result = data && data.codex_login_request_result ? data.codex_login_request_result : {};
            if (result.ok === false) await this.service.modal.error(result.message || '에이전트 인증 시작에 실패했습니다.');
        } else {
            await this.service.modal.error((data && data.message) || '에이전트 인증 시작에 실패했습니다.');
        }
        await this.service.render();
    }

    public async checkCodexLoginRequest(request: any = this.selectedCodexLoginRequest) {
        if (!request || !request.id || this.codexLoginRequestBusyId) return;
        this.codexLoginRequestBusyId = request.id;
        await this.service.render();
        const { code, data } = await wiz.call('check_codex_login_request', Object.assign(this.params(), {
            active_tab: 'codex',
            codex_refresh_target: 'requests',
            data: JSON.stringify({ id: request.id })
        }));
        this.codexLoginRequestBusyId = '';
        if (code === 200) {
            this.applyCodexData(data || {});
            if (data && data.codex_login_request) this.syncSelectedCodexLoginRequest(data.codex_login_request);
            const result = data && data.codex_login_request_result ? data.codex_login_request_result : {};
            if (result.ok) {
                await this.closeCodexLoginRequest();
                await this.service.modal.success(result.message || '에이전트 인증을 확인했습니다.');
            } else {
                await this.service.modal.error(result.message || '에이전트 인증 확인에 실패했습니다.');
            }
        } else {
            await this.service.modal.error((data && data.message) || '에이전트 인증 확인에 실패했습니다.');
        }
        await this.service.render();
    }

    public async cancelCodexLoginRequest(request: any = this.codexLoginRequestCancelTarget || this.selectedCodexLoginRequest) {
        if (!request || !request.id || this.codexLoginRequestBusyId) return;
        const adminNote = String(this.codexLoginRequestCancelReason || '').trim();
        if (!adminNote) {
            await this.service.modal.error('취소 사유를 입력해주세요.');
            return;
        }
        this.codexLoginRequestBusyId = request.id;
        await this.service.render();
        const { code, data } = await wiz.call('cancel_codex_login_request', Object.assign(this.params(), {
            active_tab: 'codex',
            codex_refresh_target: 'requests',
            data: JSON.stringify({ id: request.id, admin_note: adminNote })
        }));
        this.codexLoginRequestBusyId = '';
        if (code === 200) {
            this.applyCodexData(data || {});
            if (data && data.codex_login_request) this.syncSelectedCodexLoginRequest(data.codex_login_request);
            this.codexLoginRequestCancelTarget = null;
            this.codexLoginRequestCancelReason = '';
        } else {
            await this.service.modal.error((data && data.message) || '에이전트 인증 요청을 취소하지 못했습니다.');
        }
        await this.service.render();
    }

    public codexLogRequesterName(log: any) {
        return log?.requester_label || log?.requester_email || log?.requester_user_id || '-';
    }

    public codexLogRequesterEmail(log: any) {
        return log?.requester_email || '-';
    }

    public codexLogAccount(log: any) {
        return log?.codex_account_email || log?.codex_account_name || log?.codex_account_id || log?.codex_account_key || '-';
    }

    public codexLogAccountShort(log: any) {
        const text = this.codexLogAccount(log);
        return text.length > 20 ? `${text.slice(0, 17)}...` : text;
    }

    public codexLogRequesterOptions() {
        return Array.isArray(this.codexLogOptions && this.codexLogOptions.requesters)
            ? this.codexLogOptions.requesters
            : [];
    }

    public codexLogAccountOptions() {
        return Array.isArray(this.codexLogOptions && this.codexLogOptions.accounts)
            ? this.codexLogOptions.accounts
            : [];
    }

    public codexLogOptionLabel(option: any) {
        if (!option) return '';
        const label = option.label || option.value || '-';
        if (option.email && option.email !== label) return `${label} · ${option.email}`;
        if (option.plan) return `${label} · ${option.plan}`;
        return label;
    }

    public codexLogFilterOptions(kind: string) {
        return kind === 'account' ? this.codexLogAccountOptions() : this.codexLogRequesterOptions();
    }

    public selectedCodexLogFilterOption(kind: string) {
        const value = String(this.codexLogFilter[kind] || '');
        if (!value) return null;
        return this.codexLogFilterOptions(kind).find((option: any) => option && option.value === value) || null;
    }

    public syncCodexLogFilterSearch(kind: string) {
        const selected = this.selectedCodexLogFilterOption(kind);
        this.codexLogFilterSearch[kind] = selected ? this.codexLogOptionLabel(selected) : '';
    }

    public syncCodexLogFilterSearches() {
        this.syncCodexLogFilterSearch('requester');
        this.syncCodexLogFilterSearch('account');
    }

    public openCodexLogFilterPicker(kind: string) {
        this.codexLogFilterOpen[kind] = true;
        this.service.render();
    }

    public codexLogFilterPickerInput(kind: string) {
        this.codexLogFilterOpen[kind] = true;
        this.service.render();
    }

    public closeCodexLogFilterPickerLater(kind: string) {
        window.setTimeout(async () => {
            this.codexLogFilterOpen[kind] = false;
            this.syncCodexLogFilterSearch(kind);
            await this.service.render();
        }, 120);
    }

    public filteredCodexLogFilterOptions(kind: string) {
        const query = String(this.codexLogFilterSearch[kind] || '').trim().toLowerCase();
        return this.codexLogFilterOptions(kind).filter((option: any) => {
            const label = this.codexLogOptionLabel(option).toLowerCase();
            return !query || label.includes(query);
        }).slice(0, 80);
    }

    public async selectCodexLogFilterOption(kind: string, option: any) {
        if (!option || !option.value) return;
        this.codexLogFilter[kind] = option.value;
        this.codexLogFilterSearch[kind] = this.codexLogOptionLabel(option);
        this.codexLogFilterOpen[kind] = false;
        await this.searchCodexLogs();
    }

    public async selectFirstCodexLogFilterOption(kind: string) {
        const options = this.filteredCodexLogFilterOptions(kind);
        if (options.length) await this.selectCodexLogFilterOption(kind, options[0]);
    }

    public async clearCodexLogFilter(kind: string) {
        this.codexLogFilter[kind] = '';
        this.codexLogFilterSearch[kind] = '';
        this.codexLogFilterOpen[kind] = false;
        await this.searchCodexLogs();
    }

    public codexLogErrorButtonClass(value: string) {
        const active = this.codexLogFilter.error === value;
        const base = 'inline-flex h-8 flex-1 items-center justify-center rounded-md px-3 text-[13px] font-semibold transition';
        return active ? `${base} bg-slate-900 text-white shadow-sm` : `${base} text-slate-500 hover:bg-white hover:text-slate-900`;
    }

    public codexLogDuration(log: any) {
        const rawSeconds = log && log.work_duration_seconds !== undefined && log.work_duration_seconds !== null ? Number(log.work_duration_seconds) : 0;
        const totalSeconds = Number.isFinite(rawSeconds) ? Math.max(0, Math.floor(rawSeconds)) : 0;
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        const parts: string[] = [];
        if (minutes > 0) parts.push(`${minutes.toLocaleString('ko-KR')}분`);
        if (seconds > 0) parts.push(`${seconds.toLocaleString('ko-KR')}초`);
        return parts.length ? parts.join(' ') : '-';
    }

    public codexLogModelLabel(log: any) {
        return String(log?.model_label || log?.model || '').trim() || '기록 없음';
    }

    public codexLogReasoningEffortLabel(log: any) {
        return String(log?.model_reasoning_effort_label || log?.model_reasoning_effort || '').trim() || '기록 없음';
    }

    public codexLogRequestedModelLabel(log: any) {
        return String(log?.requested_model_label || log?.requested_model || '').trim() || '기록 없음';
    }

    public codexLogErrorClass(log: any) {
        const base = 'inline-flex shrink-0 whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-medium ';
        return log && log.error ? base + 'bg-rose-50 text-rose-700' : base + 'bg-emerald-50 text-emerald-700';
    }

    public async openCodexLog(log: any) {
        if (!log || !log.id) return;
        const requestSeq = ++this.codexLogDetailRequestSeq;
        const summary = Object.assign({}, log, {
            detail_loading: !log.detail_loaded,
            detail_error: ''
        });
        this.selectedCodexLog = summary;
        await this.service.render();
        if (log.detail_loaded) return;

        try {
            const { code, data } = await wiz.call('load_codex_log_detail', {
                data: JSON.stringify({ id: log.id })
            });
            if (requestSeq !== this.codexLogDetailRequestSeq || !this.selectedCodexLog || this.selectedCodexLog.id !== log.id) return;
            if (code === 200 && data && data.codex_log) {
                const detail = Object.assign({}, summary, data.codex_log, {
                    detail_loading: false,
                    detail_error: ''
                });
                this.selectedCodexLog = detail;
                this.codexLogs = (this.codexLogs || []).map((item: any) => item && item.id === log.id ? detail : item);
            } else {
                this.selectedCodexLog = Object.assign({}, summary, {
                    detail_loading: false,
                    detail_error: (data && data.message) || '에이전트 로그 상세를 불러오지 못했습니다.'
                });
            }
        } catch (e) {
            if (requestSeq !== this.codexLogDetailRequestSeq || !this.selectedCodexLog || this.selectedCodexLog.id !== log.id) return;
            this.selectedCodexLog = Object.assign({}, summary, {
                detail_loading: false,
                detail_error: '에이전트 로그 상세를 불러오지 못했습니다.'
            });
        }
        await this.service.render();
    }

    public async closeCodexLog() {
        this.codexLogDetailRequestSeq += 1;
        this.selectedCodexLog = null;
        await this.service.render();
    }

    public selectedCodexLogContent() {
        return this.selectedCodexLog && this.selectedCodexLog.content
            ? String(this.selectedCodexLog.content)
            : '내용 없음';
    }

    public selectedCodexLogRequestContent() {
        return this.selectedCodexLog && this.selectedCodexLog.request_content
            ? String(this.selectedCodexLog.request_content)
            : '요청 내용을 찾지 못했습니다.';
    }

    public dashboardDays() {
        return this.dashboard && this.dashboard.chart && Array.isArray(this.dashboard.chart.days)
            ? this.dashboard.chart.days
            : [];
    }

    public dashboardHours() {
        return this.dashboard && this.dashboard.chart && Array.isArray(this.dashboard.chart.hours)
            ? this.dashboard.chart.hours
            : [];
    }

    public dashboardHourSlots() {
        return this.dashboard && this.dashboard.chart && Array.isArray(this.dashboard.chart.hour_slots)
            ? this.dashboard.chart.hour_slots
            : [];
    }

    public dashboardHourTicks() {
        return this.dashboardHours().filter((hour: any) => Number(hour && hour.hour) % 3 === 0);
    }

    public userDashboardDays() {
        return this.userActivityDashboard && this.userActivityDashboard.chart && Array.isArray(this.userActivityDashboard.chart.days)
            ? this.userActivityDashboard.chart.days
            : [];
    }

    public userDashboardHours() {
        return this.userActivityDashboard && this.userActivityDashboard.chart && Array.isArray(this.userActivityDashboard.chart.hours)
            ? this.userActivityDashboard.chart.hours
            : [];
    }

    public userDashboardHourTicks() {
        const hours = this.userDashboardHours();
        return hours.filter((hour: any, index: number) => index % 24 === 0 || index === hours.length - 1);
    }

    public dashboardRanking(kind: string) {
        const rankings = this.dashboard && this.dashboard.rankings ? this.dashboard.rankings : {};
        return Array.isArray(rankings[kind]) ? rankings[kind] : [];
    }

    public dashboardActivityUsers() {
        return this.dashboard && Array.isArray(this.dashboard.activity_users) ? this.dashboard.activity_users : [];
    }

    public userDashboardRanking(kind: string) {
        const rankings = this.userActivityDashboard && this.userActivityDashboard.rankings ? this.userActivityDashboard.rankings : {};
        return Array.isArray(rankings[kind]) ? rankings[kind] : [];
    }

    public userDashboardTopProjects() {
        return this.userDashboardRanking('projects').slice(0, 5);
    }

    public userDashboardTopDistribution(kind: string) {
        return this.userDashboardDistribution(kind).slice(0, 5);
    }

    public projectActivitySegmentWidth(item: any, key: string) {
        const total = Math.max(0, Number(item && item.count ? item.count : 0));
        const value = Math.max(0, Number(item && item[key] ? item[key] : 0));
        if (!total || !value) return '0%';
        return `${(value / total) * 100}%`;
    }

    public userDashboardDistribution(kind: string) {
        const distributions = this.userActivityDashboard && this.userActivityDashboard.distributions ? this.userActivityDashboard.distributions : {};
        return Array.isArray(distributions[kind]) ? distributions[kind] : [];
    }

    public userProductivity() {
        return this.userActivityDashboard && this.userActivityDashboard.productivity
            ? this.userActivityDashboard.productivity
            : { score: 0, metrics: [], days: [], baselines: {}, formula: '' };
    }

    public userProductivityMetrics() {
        const productivity = this.userProductivity();
        return Array.isArray(productivity.metrics) ? productivity.metrics : [];
    }

    public userProductivityDays() {
        const productivity = this.userProductivity();
        return Array.isArray(productivity.days) ? productivity.days : [];
    }

    public userEvaluationMetrics() {
        const evaluation = this.userActivityDashboard && this.userActivityDashboard.evaluation ? this.userActivityDashboard.evaluation : {};
        return Array.isArray(evaluation.metrics) ? evaluation.metrics : [];
    }

    public userMethodologyItems() {
        const evaluation = this.userActivityDashboard && this.userActivityDashboard.evaluation ? this.userActivityDashboard.evaluation : {};
        return Array.isArray(evaluation.methodology) ? evaluation.methodology : [];
    }

    public userActivityMetricCards() {
        const weekly = this.userActivityPeriodSummary('weekly');
        if (weekly && Array.isArray(weekly.metrics) && weekly.metrics.length) {
            return weekly.metrics;
        }
        const productionMetrics = this.userProductivityMetrics().map((metric: any) => Object.assign({ group: 'production' }, metric));
        const evaluationMetrics = this.userEvaluationMetrics().map((metric: any) => Object.assign({ group: 'evaluation' }, metric));
        return productionMetrics.concat(evaluationMetrics);
    }

    public userActivityScore() {
        const weekly = this.userActivityPeriodSummary('weekly');
        return Number(weekly && weekly.score != null ? weekly.score : 0);
    }

    public userActivityDays() {
        return this.userProductivityDays();
    }

    public userActivityPeriodSummary(kind: string) {
        const activity = this.userActivityDashboard && this.userActivityDashboard.activity ? this.userActivityDashboard.activity : {};
        return activity && activity[kind] ? activity[kind] : { label: kind, period_label: '', score: 0, totals: {} };
    }

    public activityMetricLabel(metric: any) {
        const key = metric && metric.key ? metric.key : '';
        const labels: any = {
            qa_productivity: 'QA 생산성',
            issue_response: '이슈대응력',
            ai_utilization: 'AI 활용',
            review_quality: '리뷰 품질',
            activity_quality: '이슈 품질',
            issue_effort: '이슈 노력',
            multitasking: '멀티태스킹',
            activity_consistency: '지속성'
        };
        return labels[key] || (metric && metric.label ? metric.label : '-');
    }

    public activityMetricIcon(metric: any) {
        const key = metric && metric.key ? metric.key : '';
        const icons: any = {
            qa_productivity: 'fa-solid fa-pen-to-square text-rose-500',
            issue_response: 'fa-solid fa-list-check text-amber-500',
            ai_utilization: 'fa-solid fa-terminal text-indigo-500',
            review_quality: 'fa-solid fa-circle-check text-emerald-500',
            activity_quality: 'fa-solid fa-arrows-rotate text-cyan-500',
            issue_effort: 'fa-solid fa-code-branch text-sky-500',
            multitasking: 'fa-solid fa-layer-group text-violet-500',
            activity_consistency: 'fa-solid fa-calendar-check text-slate-500'
        };
        return icons[key] || 'fa-solid fa-chart-simple text-slate-500';
    }

    public activityMetricSummary(metric: any) {
        if (!metric) return '-';
        if (metric.summary) return metric.summary;
        if (metric.group === 'production') return `총 ${this.dashboardCount(metric.count)}건`;
        return metric.inputs || '-';
    }

    public activityMetricDetail(metric: any) {
        if (!metric) return '';
        if (metric.detail) return metric.detail;
        if (metric.group === 'production') return `기준 ${this.dashboardCount(metric.baseline_count)}건/일`;
        return metric.method || '';
    }

    public userActivityGuideItems() {
        return [
            {
                title: '현재 적용 산식',
                formula: '주간 점수 = 기간 누적량 / (90일 안정 기준 * KST 유효 일수)',
                description: '진행 중인 주/월은 KST 오늘까지의 날짜만 유효 일수에 넣고 미래 날짜는 제외합니다. 이미 지난 0건 날짜는 평균에 포함합니다.'
            },
            {
                title: '활동성 지표',
                formula: 'QA 30.7%(생산량 40 + 품질 보정 60) + 이슈 30.7%(작업량 25 + 품질 보정 60 + 노력 15) + AI 30.6% + 보조 8%',
                description: '작업량이 기본 점수이며, 품질은 작업량에 곱해지는 보정으로 반영해 적은 활동만으로 고점이 나오지 않게 합니다.'
            },
            {
                title: '주간/월간 지표',
                formula: '선택 주간 점수와 해당 월 누적 점수 병행 표시',
                description: '월간도 같은 누적 산식을 쓰며, 현재 월은 KST 오늘 이후 날짜를 유효 일수와 집계 범위에서 제외합니다.'
            },
            {
                title: '생산량 기준값',
                formula: 'max(최근 90일 사용자-일별 최대, P90, 상위 5개 사용자-일 평균)',
                description: '표본이 20개 미만이면 전체 기간을 사용합니다. 선택 주간의 상대 순위가 아니라 과거 기준값으로 분모를 고정합니다.'
            },
            {
                title: 'AI 활용',
                formula: '누적 에이전트 응답수 35% + 누적 작업시간 35% + 사용량 보정 요청 품질 30%',
                description: '요청 품질은 실제 AI 응답수나 작업시간 달성률이 있을 때만 비례 반영합니다. 후속 요청은 120자 기준으로 맥락을 평가합니다.'
            },
            {
                title: 'QA/이슈 통합',
                formula: 'QA = 생산량 40% + 생산량×리뷰품질 60%, 이슈 = 작업량 25% + 작업량×이슈품질 60% + 노력 15%',
                description: '의미 없는 리뷰/이슈 생성을 막기 위해 품질만 따로 점수를 주지 않고 실제 누적 작업량에 품질을 보정합니다.'
            },
            {
                title: '이슈 대응 노력',
                formula: '에이전트 고도화 100%',
                description: '최초 대응과 해결 소요 시간은 제외합니다. 후속 질문은 구체적인 맥락을 담아야 AI 활용에도 유리합니다.'
            },
            {
                title: '멀티태스킹',
                formula: '활동 프로젝트 수 / 10개 * 100',
                description: '선택 기간에 실제 활동이 발생한 프로젝트 수로 업무 병행 범위를 점수화합니다.'
            },
            {
                title: '지속성',
                formula: '기간 대비 활동일 40 + 시간대 25 + 리뷰 폭 35',
                description: '점수가 높게 나오기 쉬운 보조 성격을 고려해 종합 반영 비중은 4%로 낮춥니다.'
            }
        ];
    }

    public dashboardScore(value: any) {
        const score = Math.max(0, Math.min(100, Number(value || 0)));
        return score.toLocaleString('ko-KR', { maximumFractionDigits: 1 });
    }

    public dashboardScoreBarWidth(value: any) {
        return `${Math.max(4, Math.min(100, Number(value || 0)))}%`;
    }

    public productivityBaselineMeta(metric: any) {
        if (!metric || !Number(metric.baseline_count || 0)) return '기준값 없음';
        const parts = [
            metric.baseline_method || metric.baseline_label || '히스토리 안정 기준',
            `분모 ${this.dashboardCount(metric.baseline_count)}건`
        ];
        if (metric.baseline_sample_size) parts.push(`표본 ${this.dashboardCount(metric.baseline_sample_size)}개`);
        if (metric.baseline_p90_count) parts.push(`P90 ${this.dashboardCount(metric.baseline_p90_count)}건`);
        if (metric.baseline_top_average) {
            const topAverage = Number(metric.baseline_top_average || 0).toLocaleString('ko-KR', { maximumFractionDigits: 1 });
            parts.push(`상위평균 ${topAverage}건`);
        }
        return parts.join(' · ');
    }

    public productivityPeakMeta(metric: any) {
        if (!metric || !Number(metric.baseline_peak_count || 0)) return '';
        const label = metric.baseline_peak_label || metric.baseline_peak_email || '사용자 미확인';
        const date = metric.baseline_peak_date || '';
        return `최고 기록 ${date ? date + ' · ' : ''}${label} · ${this.dashboardCount(metric.baseline_peak_count)}건`;
    }

    public dashboardDailyMax() {
        return this.dashboardChartMax(this.dashboardDays(), 'daily');
    }

    public dashboardHourlyMax() {
        return this.dashboardChartMax(this.dashboardHours(), 'hourly');
    }

    public dashboardHourSlotMax() {
        return this.dashboardChartMax(this.dashboardHourSlots(), 'hourSlots');
    }

    public userDashboardDailyMax() {
        return this.dashboardChartMax(this.userDashboardDays(), 'userDaily');
    }

    public userDashboardHourlyMax() {
        return this.dashboardChartMax(this.userDashboardHours(), 'userHourly');
    }

    private scheduleChartRender() {
        if (this.chartRenderTimer) {
            clearTimeout(this.chartRenderTimer);
        }
        this.chartRenderTimer = setTimeout(() => {
            this.chartRenderTimer = null;
            this.renderCharts();
        }, 0);
    }

    private destroyCharts(scope: string = '') {
        Object.keys(this.chartInstances).forEach((key: string) => {
            if (scope && !key.startsWith(scope)) return;
            try {
                this.chartInstances[key].destroy();
            } catch (e) { }
            delete this.chartInstances[key];
        });
    }

    private chartCanvas(id: string) {
        if (typeof document === 'undefined') return null;
        return document.getElementById(id) as HTMLCanvasElement | null;
    }

    private renderCharts() {
        if (this.loading) return;
        this.renderLineChart('dashboardDaily', 'adminDashboardDailyChart', this.dashboardDays(), 'daily', 'daily');
        this.renderLineChart('dashboardHourly', 'adminDashboardHourlyChart', this.dashboardHours(), 'hourly', 'hourOfDay');
        this.renderLineChart('dashboardHourSlots', 'adminDashboardHourSlotChart', this.dashboardHourSlots(), 'hourSlots', 'hourSlots');
        if (this.userDashboardOpen && !this.userDashboardLoading) {
            this.renderLineChart('userDaily', 'adminUserDailyChart', this.userDashboardDays(), 'userDaily', 'daily');
            this.renderLineChart('userHourly', 'adminUserHourlyChart', this.userDashboardHours(), 'userHourly', 'hourSlots');
        } else {
            this.destroyCharts('user');
        }
        if (this.codexAccountUsageOpen && !this.codexAccountUsageLoading) {
            this.renderCodexAccountUsageChart();
        } else {
            this.destroyCharts('codexAccountUsage');
        }
        if (this.activeTab === 'system' && this.systemSubTab === 'monitoring') {
            this.renderSystemTrafficChart();
        } else {
            this.destroyCharts('systemTraffic');
        }
        if (this.systemLogChartModal.open) {
            this.renderSystemLogChart();
        } else {
            this.destroyCharts('systemLog');
        }
    }

    private chartLabels(items: any[], mode: string) {
        const rows = Array.isArray(items) ? items : [];
        if (mode === 'daily') {
            return rows.map((item: any) => [item.label || '', String(item.date || '').slice(5)]);
        }
        if (mode === 'hourSlots') {
            return rows.map((item: any) => `${String(item.date || '').slice(5)} ${item.label || '00'}시`);
        }
        return rows.map((item: any) => `${item.label || item.hour || '00'}시`);
    }

    private chartTitle(items: any[], mode: string, index: number) {
        const item = Array.isArray(items) ? items[index] : null;
        if (!item) return '';
        if (mode === 'daily') return `${item.date || ''} ${item.label || ''}`;
        if (mode === 'hourSlots') return `${item.date || ''} ${item.label || '00'}시`;
        return `${item.label || item.hour || '00'}시`;
    }

    private chartPercentValue(value: any) {
        if (value === null || value === undefined || value === '') return null;
        const numberValue = Number(value);
        return Number.isFinite(numberValue) ? Math.max(0, Math.min(100, numberValue)) : null;
    }

    private renderCodexAccountUsageChart() {
        const canvas = this.chartCanvas('adminCodexAccountUsageChart');
        if (!canvas) {
            this.destroyCharts('codexAccountUsage');
            return;
        }
        const rows = this.codexAccountUsageHours();
        const labels = rows.map((item: any) => item.display_label || item.datetime || item.label || String(item.date || '').slice(5));
        const datasets = [
            {
                label: 'weekly 남은 사용량',
                data: rows.map((item: any) => this.chartPercentValue(item && item.remaining_weekly)),
                borderColor: '#4f46e5',
                backgroundColor: this.chartColor('#4f46e5', 0.08),
                borderWidth: 2.2,
                pointRadius: rows.length > 72 ? 0 : (rows.length > 20 ? 2 : 3),
                pointHoverRadius: 4,
                pointBorderWidth: 1.5,
                spanGaps: true,
                tension: 0.32,
                fill: true,
            },
        ];

        this.destroyCharts('codexAccountUsage');
        this.chartInstances.codexAccountUsage = new Chart(canvas, {
            type: 'line',
            data: { labels, datasets },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                interaction: { mode: 'index', intersect: false },
                plugins: {
                    legend: {
                        display: true,
                        position: 'top',
                        labels: { boxWidth: 10, boxHeight: 10, color: '#334155', font: { size: 11, weight: '600' } },
                    },
                    tooltip: {
                        mode: 'index',
                        intersect: false,
                        callbacks: {
                            title: (items: any[]) => {
                                const index = items && items.length ? items[0].dataIndex : 0;
                                return rows[index] ? rows[index].datetime || rows[index].display_label || rows[index].date : '';
                            },
                            label: (item: any) => {
                                const value = item.raw;
                                return value === null || value === undefined
                                    ? `${item.dataset.label}: -`
                                    : `${item.dataset.label}: ${value}%`;
                            },
                        },
                    },
                },
                scales: {
                    x: {
                        grid: { display: false },
                        ticks: {
                            color: '#64748b',
                            font: { size: 11, weight: '600' },
                            maxRotation: 0,
                            autoSkip: false,
                            callback: (value: any, index: number) => this.codexAccountUsageTickLabel(rows[index], index, rows.length),
                        },
                    },
                    y: {
                        min: 0,
                        max: 100,
                        grid: { color: '#e2e8f0' },
                        ticks: {
                            color: '#64748b',
                            stepSize: 20,
                            callback: (value: any) => `${value}%`,
                        },
                    },
                },
            },
        });
    }

    private renderLineChart(key: string, canvasId: string, items: any[], scope: string, mode: string) {
        const canvas = this.chartCanvas(canvasId);
        if (!canvas) {
            this.destroyCharts(key);
            return;
        }
        const rows = Array.isArray(items) ? items : [];
        const labels = this.chartLabels(rows, mode);
        const datasets = this.dashboardVisibleSeries(scope).map((series: any) => ({
            label: series.label,
            data: rows.map((item: any) => Math.max(0, Number(item && item[series.key] ? item[series.key] : 0))),
            borderColor: series.color,
            backgroundColor: this.chartColor(series.color, 0.12),
            borderWidth: mode === 'hourSlots' ? 2 : 2.4,
            pointRadius: rows.length > 48 ? 0 : 3,
            pointHoverRadius: 4,
            pointBorderWidth: 1.5,
            tension: 0.34,
            fill: true,
        }));

        this.destroyCharts(key);
        this.chartInstances[key] = new Chart(canvas, {
            type: 'line',
            data: { labels, datasets },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                interaction: { mode: 'index', intersect: false },
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        mode: 'index',
                        intersect: false,
                        callbacks: {
                            title: (items: any[]) => {
                                const index = items && items.length ? items[0].dataIndex : 0;
                                return this.chartTitle(rows, mode, index);
                            },
                        },
                    },
                },
                scales: {
                    x: {
                        grid: { display: false },
                        ticks: {
                            color: '#64748b',
                            font: { size: 11, weight: '600' },
                            maxRotation: 0,
                            autoSkip: mode !== 'hourSlots',
                            maxTicksLimit: mode === 'hourSlots' ? 8 : 12,
                            callback: (value: any, index: number) => {
                                if (mode !== 'hourSlots') return labels[index] as any;
                                const item = rows[index] || {};
                                if (index % 24 === 0 || index === rows.length - 1) {
                                    return item.tick_label || String(item.date || '').slice(5);
                                }
                                return '';
                            },
                        },
                    },
                    y: {
                        beginAtZero: true,
                        grid: { color: '#e2e8f0' },
                        ticks: {
                            color: '#64748b',
                            precision: 0,
                            callback: (value: any) => this.dashboardCount(value),
                        },
                    },
                },
            },
        });
    }

    private renderSystemTrafficChart() {
        const canvas = this.chartCanvas('adminSystemTrafficChart');
        if (!canvas) {
            this.destroyCharts('systemTraffic');
            return;
        }
        const rows = this.systemTrafficBuckets();
        const labels = rows.map((row: any) => row.label || '');
        const color = '#2563eb';

        this.destroyCharts('systemTraffic');
        this.chartInstances.systemTraffic = new Chart(canvas, {
            type: 'bar',
            data: {
                labels,
                datasets: [{
                    label: '요청 건수',
                    data: rows.map((row: any) => Math.max(0, Number(row && row.count || 0))),
                    borderColor: color,
                    backgroundColor: this.chartColor(color, 0.62),
                    borderWidth: 1,
                    borderRadius: 3,
                    maxBarThickness: 10,
                }],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                interaction: { mode: 'index', intersect: false },
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        callbacks: {
                            title: (items: any[]) => {
                                const index = items && items.length ? items[0].dataIndex : 0;
                                const row = rows[index] || {};
                                return row.tooltip_label || row.bucket || row.label || '';
                            },
                            label: (item: any) => `요청 건수: ${this.dashboardCount(item.raw)}`,
                        },
                    },
                },
                scales: {
                    x: {
                        grid: { display: false },
                        title: {
                            display: true,
                            text: `${this.systemTrafficSummary().bucket_label || '10분'} 단위 (${this.systemWebLogs().timezone || 'UTC+9'})`,
                            color: '#475569',
                            font: { size: 12, weight: '600' },
                        },
                        ticks: {
                            color: '#64748b',
                            font: { size: 10, weight: '600' },
                            maxRotation: 0,
                            autoSkip: false,
                            callback: (value: any, index: number) => {
                                const row = rows[index] || {};
                                return row.tick_label || '';
                            },
                        },
                    },
                    y: {
                        beginAtZero: true,
                        title: {
                            display: true,
                            text: '건수',
                            color: '#475569',
                            font: { size: 12, weight: '600' },
                        },
                        grid: { color: '#e2e8f0' },
                        ticks: {
                            color: '#64748b',
                            precision: 0,
                            callback: (value: any) => this.dashboardCount(value),
                        },
                    },
                },
            },
        });
    }

    private renderSystemLogChart() {
        const canvas = this.chartCanvas('adminSystemLogChart');
        if (!canvas) {
            this.destroyCharts('systemLog');
            return;
        }
        const isErrors = this.systemLogChartModal.type === 'errors';
        const rows = isErrors ? this.systemLogHourlyErrors() : this.systemLogDurationHistogram();
        const labels = rows.map((row: any) => row.label || row.hour || row.key || '-');
        const normalColor = '#2563eb';
        const errorColor = '#e11d48';
        const datasets = isErrors
            ? [{
                label: '오류 건수',
                data: rows.map((row: any) => Math.max(0, Number(row && row.count || 0))),
                borderColor: errorColor,
                backgroundColor: this.chartColor(errorColor, 0.72),
                borderWidth: 1,
                borderRadius: 4,
                maxBarThickness: 12,
            }]
            : [{
                label: '정상 응답',
                data: rows.map((row: any) => {
                    const fallback = Number(row && row.count || 0) - Number(row && row.error_count || 0);
                    return Math.max(0, Number(row && row.normal_count !== undefined ? row.normal_count : fallback));
                }),
                borderColor: normalColor,
                backgroundColor: this.chartColor(normalColor, 0.68),
                borderWidth: 1,
                borderRadius: 4,
                maxBarThickness: 48,
                stack: 'responses',
            }, {
                label: '오류 응답',
                data: rows.map((row: any) => Math.max(0, Number(row && row.error_count || 0))),
                borderColor: errorColor,
                backgroundColor: this.chartColor(errorColor, 0.72),
                borderWidth: 1,
                borderRadius: 4,
                maxBarThickness: 48,
                stack: 'responses',
            }];

        this.destroyCharts('systemLog');
        this.chartInstances.systemLog = new Chart(canvas, {
            type: 'bar',
            data: {
                labels,
                datasets,
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                interaction: { mode: 'index', intersect: false },
                plugins: {
                    legend: {
                        display: true,
                        position: 'top',
                        labels: { boxWidth: 10, boxHeight: 10, color: '#334155', font: { size: 11, weight: '600' } },
                    },
                    tooltip: {
                        callbacks: {
                            title: (items: any[]) => {
                                const index = items && items.length ? items[0].dataIndex : 0;
                                const row = rows[index] || {};
                                return isErrors ? (row.hour || row.label || '') : (row.label || '');
                            },
                            label: (item: any) => `${item.dataset.label}: ${this.dashboardCount(item.raw)}`,
                        },
                    },
                },
                scales: {
                    x: {
                        stacked: !isErrors,
                        grid: { display: false },
                        title: {
                            display: true,
                            text: isErrors ? `발생 시각 (${this.systemWebLogs().timezone || 'UTC+9'})` : '응답시간',
                            color: '#475569',
                            font: { size: 12, weight: '600' },
                        },
                        ticks: {
                            color: '#64748b',
                            font: { size: 11, weight: '600' },
                            maxRotation: 0,
                            autoSkip: isErrors,
                            maxTicksLimit: isErrors ? 12 : 8,
                            callback: (value: any, index: number) => {
                                if (!isErrors) return labels[index] as any;
                                const row = rows[index] || {};
                                return row.tick_label || (index % 6 === 0 ? row.hour_label : '');
                            },
                        },
                    },
                    y: {
                        stacked: !isErrors,
                        beginAtZero: true,
                        title: {
                            display: true,
                            text: '건수',
                            color: '#475569',
                            font: { size: 12, weight: '600' },
                        },
                        grid: { color: '#e2e8f0' },
                        ticks: {
                            color: '#64748b',
                            precision: 0,
                            callback: (value: any) => this.dashboardCount(value),
                        },
                    },
                },
            },
        });
    }

    private chartColor(hex: string, alpha: number) {
        const value = String(hex || '').replace('#', '');
        if (value.length !== 6) return `rgba(15, 23, 42, ${alpha})`;
        const r = parseInt(value.slice(0, 2), 16);
        const g = parseInt(value.slice(2, 4), 16);
        const b = parseInt(value.slice(4, 6), 16);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }

    public lineChartX(index: number, total: number) {
        if (total <= 1) return this.chartPlot.left;
        return this.chartPlot.left + (index / (total - 1)) * (this.chartPlot.right - this.chartPlot.left);
    }

    public lineChartY(item: any, key: string, maxValue: number) {
        const value = Math.max(0, Number(item && item[key] ? item[key] : 0));
        const max = Math.max(1, Number(maxValue || 1));
        return this.chartPlot.bottom - (value / max) * (this.chartPlot.bottom - this.chartPlot.top);
    }

    public lineChartPoints(items: any[], key: string, maxValue: number) {
        const rows = Array.isArray(items) ? items : [];
        return rows.map((item: any, index: number) => {
            return `${this.lineChartX(index, rows.length).toFixed(2)},${this.lineChartY(item, key, maxValue).toFixed(2)}`;
        }).join(' ');
    }

    public async toggleChartSeries(scope: string, key: string) {
        const selected = this.dashboardChartSelection[scope] || '';
        this.dashboardChartSelection[scope] = selected === key ? '' : key;
        await this.service.render();
        this.scheduleChartRender();
    }

    public isChartSeriesVisible(scope: string, key: string) {
        const selected = this.dashboardChartSelection[scope] || '';
        return !selected || selected === key;
    }

    public dashboardVisibleSeries(scope: string) {
        return this.dashboardSeries.filter((series: any) => this.isChartSeriesVisible(scope, series.key));
    }

    public chartLegendPressed(scope: string, key: string) {
        return this.dashboardChartSelection[scope] === key ? 'true' : 'false';
    }

    public chartLegendClass(scope: string, key: string) {
        const active = this.isChartSeriesVisible(scope, key);
        const base = 'inline-flex h-8 items-center gap-1.5 rounded-md border px-2.5 text-[11px] font-semibold transition';
        return active
            ? `${base} border-slate-300 bg-white text-slate-900 shadow-sm`
            : `${base} border-slate-200 bg-slate-100 text-slate-400 hover:border-slate-300 hover:text-slate-600`;
    }

    public dashboardChartMax(items: any[], scope: string) {
        const rows = Array.isArray(items) ? items : [];
        const visibleKeys = this.dashboardSeries
            .filter((series: any) => this.isChartSeriesVisible(scope, series.key))
            .map((series: any) => series.key);
        const maxValue = rows.reduce((max: number, row: any) => {
            const rowMax = visibleKeys.reduce((seriesMax: number, key: string) => {
                return Math.max(seriesMax, Math.max(0, Number(row && row[key] ? row[key] : 0)));
            }, 0);
            return Math.max(max, rowMax);
        }, 1);
        return this.chartNiceMax(maxValue);
    }

    public chartNiceMax(value: any) {
        const max = Math.max(1, Math.ceil(Number(value || 1)));
        if (max <= 4) return 4;
        const rawStep = max / 4;
        const magnitude = Math.pow(10, Math.floor(Math.log10(rawStep)));
        const scaled = rawStep / magnitude;
        let multiplier = 1;
        if (scaled <= 1) multiplier = 1;
        else if (scaled <= 2) multiplier = 2;
        else if (scaled <= 3) multiplier = 3;
        else if (scaled <= 5) multiplier = 5;
        else multiplier = 10;
        return multiplier * magnitude * 4;
    }

    public chartYAxisTicks(maxValue: number) {
        const max = this.chartNiceMax(maxValue);
        const step = max / 4;
        return [4, 3, 2, 1, 0].map((multiplier: number) => {
            const value = Math.round(step * multiplier);
            return { value, label: this.dashboardCount(value) };
        });
    }

    public chartTickY(value: number, maxValue: number) {
        const max = Math.max(1, Number(maxValue || 1));
        return this.chartPlot.bottom - (Math.max(0, Number(value || 0)) / max) * (this.chartPlot.bottom - this.chartPlot.top);
    }

    public async moveDashboardWeek(direction: number) {
        const period = this.dashboard && this.dashboard.period ? this.dashboard.period : {};
        this.dashboardWeekStart = direction < 0 ? (period.previous_start || '') : (period.next_start || '');
        await this.load('period');
    }

    public async resetDashboardWeek() {
        this.dashboardWeekStart = '';
        await this.load('period');
    }

    public dashboardCount(value: any) {
        const count = Math.max(0, Number(value || 0));
        return count.toLocaleString('ko-KR');
    }

    public dashboardRankBarWidth(item: any) {
        return `${Math.max(4, Math.min(100, Number(item && item.percent ? item.percent : 0)))}%`;
    }

    public dashboardRankSubLabel(item: any, kind: string) {
        if (!item) return '';
        if (kind === 'codex_users' || kind === 'codex_accounts') {
            return item.duration_label ? `작업시간 ${item.duration_label}` : '';
        }
        return item.email || '';
    }

    public dashboardAccountMeta(item: any) {
        if (!item) return '';
        const parts = [item.name, item.plan, item.organization].filter((value: any) => !!value);
        return parts.length ? parts.join(' · ') : '계정 상세 없음';
    }

    public dashboardRankEmpty(kind: string) {
        return this.dashboardRanking(kind).length === 0;
    }

    public userDashboardRankEmpty(kind: string) {
        return this.userDashboardRanking(kind).length === 0;
    }

    public userDashboardDistributionEmpty(kind: string) {
        return this.userDashboardDistribution(kind).length === 0;
    }

    public distributionBarWidth(item: any) {
        return `${Math.max(4, Math.min(100, Number(item && item.percent ? item.percent : 0)))}%`;
    }
}

export default PageAdminComponent;